const ru = {
  app: { name: 'Ватман', tagline: 'Онлайн-доска для команд' },
  common: {
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    rename: 'Переименовать',
    close: 'Закрыть',
    copy: 'Копировать',
    done: 'Готово',
    loading: 'Загрузка…',
    back: 'Назад',
    search: 'Поиск',
    create: 'Создать',
    invite: 'Пригласить',
    remove: 'Убрать',
    leave: 'Выйти',
    you: 'вы',
    untitled: 'Без названия',
    open: 'Открыть',
    settings: 'Настройки',
    members: 'Участники',
    more: 'Ещё',
    retry: 'Повторить',
    copied: 'Скопировано',
    or: 'или',
  },
  errors: {
    team_not_empty: 'В команде ещё есть проекты, доски (в том числе в корзине), страницы, спринты или другие пространства — перенесите или удалите их',
    last_team: 'Это последняя команда организации',
    personal_team: 'Личную команду удалить нельзя',
    team_not_in_project: 'Эта команда не работает в проекте',
    home_team: 'Основную команду проекта так не изменить',
    other_org: 'Эта команда из другой организации',
    personal_project: 'Личный проект нельзя открыть другим командам',
    invalid_space: 'Это пространство другой команды или его нет',
    invalid_points: 'Story points — число от 0 до 1000',
    invalid_dates: 'Конец спринта раньше начала',
    invalid_capacity: 'Ёмкость — неотрицательное число',
    invalid_estimation: 'Неизвестный способ оценки',
    invalid_state: 'Со спринтом в таком состоянии так нельзя',
    invalid_move: 'Не понял, куда переставить спринт',
    ambiguous_key: 'Задача с таким ключом есть в нескольких ваших организациях — откройте её из проекта',
    default_space: 'Основное пространство команды нельзя удалить',
    comment_exists: 'Такой комментарий уже есть — обновите страницу',
    invalid_comment: 'Комментарий пустой или слишком длинный',
    invalid_anchor: 'Не удалось прикрепить комментарий к месту на доске',
    invalid_emoji: 'Такую реакцию поставить нельзя',
    too_many_reactions: 'На сообщении уже слишком много разных реакций',
    comments_moved: 'Комментарии переехали — обновите страницу',
    too_many_spaces: 'В команде слишком много пространств',
    invalid_icon: 'Такой значок не подходит — выберите из списка или загрузите картинку',
    icon_too_big: 'Картинка слишком большая',
    guests_off: 'Организация не разрешает приглашать людей со стороны',
    not_a_guest: 'Это участник организации, а не гость',
    csv_unreadable: 'Не получилось прочитать файл как таблицу CSV',
    no_rows: 'В таблице нет строк с задачами',
    table_too_large: 'Таблица слишком большая: до 50 000 строк и 300 колонок',
    title_column_required: 'Укажите колонку с названием задачи',
    invalid_role: 'Неизвестная роль',
    team_admin: 'Владельцы и администраторы команды всегда управляют проектом',
    invalid_frequency: 'Неизвестная частота писем',
    invalid_minutes: 'Время — от 1 минуты до недели',
    invalid_date: 'Неверная дата',
    invalid_period: 'Период — не больше квартала',
    note_too_long: 'Слишком длинный комментарий',
    invalid_wip_limit: 'Лимит — от 1 до 999',
    consent_required: 'Примите условия и дайте согласие на обработку персональных данных',
    confirm_mismatch: 'Введите почту аккаунта, чтобы подтвердить',
    invalid_repo_url: 'Нужен адрес репозитория вида https://github.com/команда/проект.',
    invalid_provider: 'Выберите GitHub, GitLab, Gitea или Bitbucket.',
    repo_exists: 'Этот репозиторий уже подключён.',
    too_many_repos: 'У команды уже 100 репозиториев.',
    invalid_query: 'Запрос пустой или слишком длинный.',
    invalid_team: 'Выберите команду, в которой вы состоите.',
    too_many_filters: 'У вас уже 100 фильтров — удалите ненужные.',
    too_many: 'Можно изменить до 500 задач за раз.',
    file_too_large: 'Файл больше 25 МБ — так много за раз не загрузить.',
    too_many_attachments: 'У задачи уже 200 файлов — больше прикрепить нельзя.',
    length_required: 'Браузер не сообщил размер файла. Попробуйте ещё раз.',
    attachment_exists: 'Этот файл уже прикреплён.',
    transition_not_allowed: 'В этот статус нельзя перейти из текущего — так настроен проект.',
    required_assignee: 'Для этого статуса нужен исполнитель.',
    required_estimate: 'Для этого статуса нужна оценка.',
    required_due: 'Для этого статуса нужен срок.',
    required_description: 'Для этого статуса нужно описание.',
    required_labels: 'Для этого статуса нужна хотя бы одна метка.',
    required_sprint: 'Для этого статуса задача должна быть в спринте.',
    last_status: 'Последний статус удалить нельзя.',
    last_done_status: 'В проекте должен остаться хотя бы один статус категории «Готово».',
    move_to_required: 'Выберите, куда перенести задачи из этого статуса.',
    status_exists: 'Статус с таким названием уже есть.',
    too_many_statuses: 'В проекте может быть не больше 30 статусов.',
    invalid_color: 'Некорректный цвет.',
    invalid_order: 'Статусы изменились — обновите страницу.',
    invalid_status: 'Такого статуса в проекте нет.',
    invalid_required_field: 'Это поле нельзя сделать обязательным.',
    invalid_link: 'Такую связь сделать нельзя — проверьте задачу.',
    too_many_links: 'У задачи слишком много связей.',
    import_invalid_url: 'Проверьте адрес: нужен адрес сайта, откуда переносите (Jira, YouTrack, Confluence).',
    import_blocked_address: 'Этот адрес из внутренней сети — к нему Ватман не обращается.',
    import_unauthorized: 'Не удалось войти: проверьте адрес, почту и токен.',
    import_forbidden: 'У токена нет доступа к этим данным.',
    import_not_found: 'Не нашли: проверьте адрес и проект или пространство.',
    import_rate_limited: 'Система просит подождать — попробуйте через минуту.',
    import_timeout: 'Сервер долго не отвечает. Попробуйте ещё раз.',
    import_network: 'Не удалось соединиться с сервером.',
    import_bad_response: 'Сервер ответил не так, как ожидалось. Проверьте адрес и выбранную систему.',
    import_running: 'Уже идут два импорта — дождитесь их окончания.',
    import_already_running: 'Этот перенос уже идёт — дождитесь окончания.',
    invalid_archive: 'Это не ZIP-архив или он повреждён.',
    archive_too_large: 'Архив слишком большой: до 512 МБ и 20 000 файлов.',
    invalid_system: 'Эта система здесь не поддерживается.',
    too_many_labels: 'У страницы может быть не больше 50 меток.',
    key_taken: 'Такой ключ уже есть у другого проекта.',
    interrupted: 'Импорт прервался — запустите его снова, он продолжит без дублей.',
    internal: 'Что-то пошло не так. Попробуйте ещё раз.',
    unauthorized: 'Нужно войти в аккаунт.',
    forbidden: 'Недостаточно прав.',
    not_found: 'Не найдено.',
    too_many_requests: 'Слишком много попыток. Подождите немного.',
    invalid_email: 'Проверьте адрес почты.',
    weak_password: 'Пароль — минимум 8 символов.',
    invalid_name: 'Укажите имя.',
    email_taken: 'Этот адрес уже зарегистрирован. Войдите или восстановите пароль.',
    invalid_credentials: 'Неверная почта или пароль.',
    invalid_token: 'Ссылка устарела или уже использована.',
    email_not_verified: 'Сначала подтвердите свою почту.',
    last_owner: 'Нельзя убрать последнего владельца.',
    domain_not_owned: 'Можно указать только домен вашей подтверждённой почты.',
    invalid_domain: 'Некорректный домен.',
    not_in_org: 'Этот человек не состоит в организации.',
    oauth_failed: 'Не удалось войти через внешний сервис.',
    telegram_unavailable: 'Telegram сейчас не отвечает — попробуйте чуть позже.',
    oauth_no_email: 'Сервис не передал адрес почты.',
    unsupported_type: 'Этот формат файла не поддерживается.',
    no_org: 'Доска не принадлежит организации.',
    use_transfer: 'Чтобы сменить владельца, используйте передачу доски.',
    template_too_large: 'Слишком большой шаблон: не больше 5000 объектов и 2 МБ.',
    empty_template: 'В шаблоне нет ни одного объекта.',
    invalid_category: 'Выберите категорию.',
    invalid_scope: 'Выберите, кому доступен шаблон.',
    description_too_long: 'Описание длиннее 1000 символов.',
    invalid_access: 'Выберите права токена.',
    invalid_expiry: 'Некорректный срок действия.',
    too_many_tokens: 'Слишком много токенов: отзовите ненужные.',
    invalid_boards: 'Выберите доски, к которым у вас есть доступ.',
  },
  legal: {
    acceptTerms: 'Принимаю <terms>пользовательское соглашение</terms> и ознакомлен(а) с <privacy>политикой обработки персональных данных</privacy>',
    acceptPd: 'Даю <consent>согласие на обработку персональных данных</consent>',
    gateTitle: 'Примите условия',
    gateText: 'Чтобы продолжить работу в Ватмане, примите условия сервиса и дайте согласие на обработку персональных данных.',
    accept: 'Продолжить',
    deleteMenu: 'Удалить аккаунт',
    deleteTitle: 'Удалить аккаунт?',
    deleteGone: 'Удалятся ваши почта, имя, пароль, входы через Яндекс и VK, токены агентов, уведомления и личное пространство со всеми досками, задачами и файлами.',
    deleteStay: 'Доски и проекты общих команд останутся у команды: владельцем станет другой участник. В истории, комментариях и задачах вместо имени будет «Удалённый пользователь».',
    deleteFinal: 'Это необратимо. Почту можно будет снова использовать для нового аккаунта.',
    deletePolicy: 'Подробнее — в <privacy>политике обработки персональных данных</privacy>.',
    deleteConfirm: 'Чтобы подтвердить, введите {{email}}',
    deleteButton: 'Удалить навсегда',
  },
  auth: {
    loginTitle: 'Вход в Ватман',
    registerTitle: 'Создать аккаунт',
    email: 'Рабочая почта',
    password: 'Пароль',
    name: 'Имя',
    namePlaceholder: 'Как к вам обращаться',
    login: 'Войти',
    register: 'Зарегистрироваться',
    noAccount: 'Нет аккаунта?',
    haveAccount: 'Уже есть аккаунт?',
    forgot: 'Забыли пароль?',
    magic: 'Войти по ссылке на почту',
    magicSent: 'Мы отправили ссылку для входа на {{email}}. Она действует 15 минут.',
    forgotTitle: 'Восстановление пароля',
    forgotHint: 'Пришлём ссылку для смены пароля.',
    forgotSent: 'Если адрес зарегистрирован, письмо уже в пути.',
    send: 'Отправить',
    resetTitle: 'Новый пароль',
    resetSave: 'Сохранить пароль',
    withYandex: 'Войти с Яндекс ID',
    withVk: 'Войти с VK ID',
    verifying: 'Подтверждаем почту…',
    verified: 'Почта подтверждена',
    verifyBanner: 'Подтвердите почту {{email}}, чтобы приглашать коллег.',
    resend: 'Отправить письмо ещё раз',
    resent: 'Письмо отправлено',
    signingIn: 'Входим…',
    logout: 'Выйти',
    terms: 'Регистрируясь, вы соглашаетесь с условиями использования и политикой обработки персональных данных.',
    heroTitle: 'Думайте вместе.\nНа одном ватмане.',
    heroText: 'Стикеры, схемы, ретро и планирование — в реальном времени, с командой до сотни человек на одной доске.',
  },
  favorites: {
    title: 'Избранное',
    add: 'В избранное',
    remove: 'Убрать из избранного',
  },
  nav: {
    newBoard: 'Новая доска',
    newPage: 'Новая страница',
    newProject: 'Новый проект',
    openNewTab: 'Открыть в новой вкладке',
    copyLink: 'Скопировать ссылку',
    linkCopied: 'Ссылка скопирована',
    rename: 'Переименовать',
    renamePage: 'Переименовать страницу',
    renameProject: 'Переименовать проект',
    hide: 'Скрыть меню',
    show: 'Показать меню',
    resize: 'Ширина меню: потяните, двойной клик — обычная',
    home: 'Все доски',
    recent: 'Недавние',
    starred: 'Избранное',
    mine: 'Мои доски',
    shared: 'Доступные мне',
    trash: 'Корзина',
    teams: 'Команды',
    projects: 'Проекты',
    personal: 'Личное',
    newOrg: 'Создать организацию',
    orgSettings: 'Настройки организации',
    profile: 'Профиль',
    language: 'Язык',
    theme: 'Тема',
    light: 'Светлая',
    dark: 'Тёмная',
    system: 'Как в системе',
    menu: 'Меню',
    members: 'Участники',
    importMiro: 'Импорт досок из Miro',
    importIssues: 'Импорт задач (Jira, YouTrack…)',
    importDocs: 'Импорт документов (Confluence, Notion…)',
    starredRecent: 'Избранное и недавние',
    everything: 'Всё в организации',
    everythingPersonal: 'Все доски и проекты',
    recentProjects: 'Недавние проекты',
    recentBoards: 'Недавние доски',
  },
  dashboard: {
    newBoard: 'Новая доска',
    searchBoards: 'Искать доски',
    startWith: 'Начать с шаблона',
    empty: 'Здесь пока нет досок',
    emptyHint: 'Создайте первую доску или начните с шаблона.',
    emptyTrash: 'Корзина пуста',
    trashHint: 'Удалённые доски хранятся здесь, пока вы не удалите их навсегда.',
    noResults: 'Ничего не нашлось',
    edited: 'Изменена {{time}}',
    owner: 'Владелец: {{name}}',
    star: 'В избранное',
    unstar: 'Убрать из избранного',
    duplicate: 'Дублировать',
    moveTo: 'Переместить в проект',
    noProject: 'Без проекта',
    toTrash: 'В корзину',
    restore: 'Восстановить',
    purge: 'Удалить навсегда',
    purgeConfirm: 'Доска будет удалена без возможности восстановления.',
    newProject: 'Новый проект',
    projectName: 'Название проекта',
    newTeam: 'Новая команда',
    chip: { all: 'Все доски', mine: 'Мои доски', shared: 'Доступные мне', projects: 'Проекты' },
    noStarred: 'Отметьте доску звёздочкой — она появится здесь.',
    teamName: 'Название команды',
    joinTeam: 'Вступить',
    allTeams: 'Все команды организации',
    sortBy: 'Сортировка',
    sortUpdated: 'По изменению',
    sortName: 'По названию',
    grid: 'Плиткой',
    list: 'Списком',
    joinOrgs: 'Ваши коллеги уже в Ватмане',
    joinOrg: 'Присоединиться',
    boardsCount_one: '{{count}} доска',
    boardsCount_few: '{{count}} доски',
    boardsCount_many: '{{count}} досок',
    boardsCount_other: '{{count}} доски',
  },
  org: {
    createTitle: 'Новая организация',
    createHint: 'Организация объединяет команды компании: общий список участников, команды и доски с доступом «все в организации».',
    name: 'Название организации',
    namePlaceholder: 'Например, Slicetech',
    members: 'Участники организации',
    invitePlaceholder: 'Почты через запятую или с новой строки',
    invite: 'Пригласить',
    pending: 'Ожидают принятия',
    domains: 'Вход по домену почты',
    domainsHint: 'Сотрудники с подтверждённой почтой на этом домене смогут присоединиться сами.',
    teams: 'Команды',
    roles: { owner: 'Владелец', admin: 'Администратор', member: 'Участник' },
    invited: 'Приглашения отправлены',
    leave: 'Покинуть организацию',
  },
  roles: {
    owner: 'Владелец',
    editor: 'Может редактировать',
    commenter: 'Может комментировать',
    viewer: 'Может смотреть',
    none: 'Нет доступа',
  },
  search: {
    placeholder: 'Искать доски и содержимое',
    titleAndContent: 'Найдено: {{count}}',
    inItems: 'На доске',
    inComments: 'В комментариях',
    moreItems_one: 'ещё {{count}} совпадение',
    moreItems_few: 'ещё {{count}} совпадения',
    moreItems_many: 'ещё {{count}} совпадений',
    moreItems_other: 'ещё {{count}} совпадения',
    noResults: 'Ничего не нашлось',
    noResultsHint: 'Поиск идёт по названиям, тексту на досках и комментариям. Попробуйте другое слово.',
    itemNotFound: 'Объект не найден — возможно, его удалили.',
  },
  notifications: {
    modeHint: 'Когда присылать',
    mode: { instant: 'Сразу', hourly: 'Сводкой раз в час', daily: 'Сводкой раз в день, в 9:00' },
    title: 'Уведомления',
    open: 'Уведомления',
    unread_one: '{{count}} непрочитанное',
    unread_few: '{{count}} непрочитанных',
    unread_many: '{{count}} непрочитанных',
    unread_other: '{{count}} непрочитанного',
    markAllRead: 'Прочитать все',
    empty: 'Пока ничего нет',
    emptyHint: 'Здесь появятся упоминания, ответы в обсуждениях и приглашения.',
    more: 'Показать ещё',
    mention: '{{name}} упоминает вас на доске «{{board}}»',
    reply: '{{name}} отвечает в обсуждении на доске «{{board}}»',
    board_shared: '{{name}} открывает вам доску «{{board}}»',
    team_invite: '{{name}} добавляет вас в команду «{{team}}»',
    org_invite: '{{name}} добавляет вас в организацию «{{org}}»',
    project_shared: '{{name}} приглашает вас в проект «{{project}}» ({{role}})',
    issue_assigned: '{{name}} назначает вам {{issue}} «{{title}}»',
    issue_commented: '{{name}} комментирует {{issue}} «{{title}}»',
    issue_status: '{{name}} переводит {{issue}} «{{title}}» в «{{status}}»',
    issue_due: 'Срок {{issue}} «{{title}}» — {{when}}',
    issue_mention: '{{name}} упоминает вас в {{issue}} «{{title}}»',
    page_mention: '{{name}} упоминает вас на странице «{{page}}»',
    page_comment: '{{name}} комментирует страницу «{{page}}»',
    page_review_requested: '{{name}} просит согласовать «{{page}}»',
    page_review_decided: '{{name}} согласует «{{page}}»',
    page_review_changes: '{{name}} просит доработать «{{page}}»',
    page_review_done: '{{name}} завершает согласование: «{{page}}» согласована',
    page_review_due: 'Срок согласования «{{page}}» — {{when}}',
    space_post: '{{name}} публикует «{{page}}» в «{{space}}»',
    due: { overdue: 'просрочен', today: 'сегодня', tomorrow: 'завтра', later: 'скоро' },
    unknown: 'Новое уведомление',
    emails: 'Письма на почту',
    emailHint: 'Уведомления в Ватмане приходят всегда. Здесь — какие из них дублировать письмом.',
    email: {
      mention: 'Упоминания',
      reply: 'Ответы в обсуждениях',
      share: 'Доступ к доскам',
      invite: 'Приглашения в команды',
      issues: 'Задачи: назначения, комментарии, статусы, сроки',
      reviews: 'Согласование документов',
      news: 'Новости пространств',
    },
    telegram: {
      title: 'Telegram',
      hint: 'Уведомления будут приходить в чат с ботом @{{bot}}.',
      hintNoBot: 'Уведомления будут приходить в чат с ботом Ватмана.',
      connect: 'Подключить Telegram',
      opened: 'В Telegram нажмите «Запустить» — бот подключится сам.',
      linked: 'Подключён: @{{name}}',
      linkedNoName: 'Telegram подключён',
      groupsHint: 'Что присылать в Telegram',
      disconnect: 'Отключить Telegram',
      disconnected: 'Telegram отключён',
    },
  },
  access: {
    none: 'Нет доступа',
    view: 'Может смотреть',
    comment: 'Может комментировать',
    edit: 'Может редактировать',
  },
  share: {
    title: 'Поделиться доской',
    invitePlaceholder: 'Почта или имя коллеги',
    linkAccess: 'Все, у кого есть ссылка',
    teamAccess: 'Команда «{{name}}»',
    spaceAccess: 'Пространство «{{name}}»',
    spaceHint: 'Каждый — не выше своей роли в пространстве.',
    privateSpaceHint: 'Пространство закрытое: организации доска не видна.',
    orgAccess: 'Вся организация «{{name}}»',
    copyLink: 'Скопировать ссылку',
    people: 'Люди с доступом',
    pending: 'Приглашение отправлено',
    transfer: 'Сделать владельцем',
    onlyOwner: 'Настройки доступа меняет владелец доски.',
    linkHint: 'Даже без аккаунта — по ссылке.',
  },
  board: {
    loading: 'Открываем доску…',
    notFound: 'Доска не найдена или у вас нет к ней доступа',
    notFoundHint: 'Попросите владельца поделиться доской или проверьте ссылку.',
    deleted: 'Доска удалена',
    toDashboard: 'К списку досок',
    readOnly: 'Только просмотр',
    offline: 'Нет связи — изменения сохранятся и отправятся позже',
    connecting: 'Подключение…',
    online: 'Все изменения сохранены',
    signInToEdit: 'Войдите, чтобы редактировать',
    share: 'Поделиться',
    present: 'Презентация',
    frames: 'Фреймы',
    noFrames: 'Добавьте фреймы — они станут слайдами презентации.',
    following: 'Вы следуете за {{name}}',
    stopFollowing: 'Перестать следовать',
    follow: 'Следовать за {{name}}',
    summon: 'Собрать всех ко мне',
    summoned: 'Участники перенесены к вам',
    frame: 'Фрейм',
    emptyTitle: 'Чистый лист',
    emptyHint: 'Дважды кликните, чтобы добавить стикер, или выберите шаблон.',
    pickTemplate: 'Выбрать шаблон',
    uploading: 'Загружаем изображение…',
    uploadFailed: 'Не удалось загрузить изображение',
    exportPng: 'Экспорт в PNG',
    exportPdf: 'Экспорт фреймов в PDF',
    exportingPdf: 'Готовим PDF…',
    nothingToExport: 'На доске пока нечего экспортировать',
    exportJson: 'Скачать копию (.json)',
    importJson: 'Импорт из файла (.json)',
    duplicateBoard: 'Создать копию доски',
    boardCopied: 'Копия доски создана',
    shortcuts: 'Горячие клавиши',
    commands: 'Команды',
    grid: 'Сетка',
    theme: 'Тема',
    motion: 'Анимации',
    motionOn: 'Включены',
    motionOff: 'Выключены',
    motionSystem: 'Как в системе',
    rename: 'Переименовать доску',
    undo: 'Отменить',
    redo: 'Повторить',
    menu: 'Меню доски',
    zoomIn: 'Приблизить',
    zoomOut: 'Отдалить',
    zoomFit: 'Показать всё',
    zoomReset: 'Масштаб 100%',
    minimap: 'Мини-карта',
    help: 'Справка',
  },
  tools: {
    select: 'Выделение',
    hand: 'Рука',
    sticky: 'Стикер',
    shape: 'Фигуры',
    text: 'Текст',
    connector: 'Линия',
    pen: 'Перо',
    highlighter: 'Маркер',
    eraser: 'Ластик',
    frame: 'Фрейм',
    image: 'Изображение',
    comment: 'Комментарий',
    card: 'Карточка задачи',
    stamp: 'Штамп',
    laser: 'Лазерная указка',
    templates: 'Шаблоны',
    more: 'Ещё',
  },
  shapes: {
    rect: 'Прямоугольник',
    rounded: 'Скруглённый',
    ellipse: 'Эллипс',
    triangle: 'Треугольник',
    diamond: 'Ромб',
    hexagon: 'Шестиугольник',
    parallelogram: 'Параллелограмм',
    star: 'Звезда',
    cylinder: 'Цилиндр',
    callout: 'Выноска',
    arrow: 'Стрелка',
  },
  cards: {
    title: 'Задача',
    untitled: 'Без названия',
    titlePlaceholder: 'Название задачи',
    descriptionPlaceholder: 'Добавьте описание…',
    status: 'Статус',
    statuses: { todo: 'К работе', doing: 'В работе', done: 'Готово' },
    assignee: 'Исполнитель',
    unassigned: 'Не назначен',
    searchPeople: 'Найти участника доски',
    noPeople: 'Никого не нашли',
    peopleSignIn: 'Войдите, чтобы назначать задачи.',
    due: 'Срок',
    clearDue: 'Убрать срок',
    overdue: 'Просрочено',
    tags: 'Теги',
    addTag: 'Добавить тег',
    removeTag: 'Убрать тег «{{tag}}»',
    color: 'Цвет',
    details: 'Открыть задачу',
    zoomTo: 'Показать на доске',
    delete: 'Удалить карточку',
    convert: 'Превратить в карточки',
    converted: 'Карточек из стикеров: {{count}}',
    issue: 'Задача',
    openIssue: 'Открыть в трекере',
    unlinkIssue: 'Отвязать от задачи',
    createIssue: 'Создать',
    linkIssue: 'Связать',
    pickProject: 'В каком проекте',
    noProjects: 'Нет проектов, где вы можете создавать задачи. Создайте проект в разделе «Задачи».',
    searchIssues: 'Ключ или слова из названия',
    issueCreated: 'Задача {{key}} создана и связана с карточкой',
    issueLinked: 'Карточка связана с {{key}}',
    syncFailed: '{{key}} не обновилась: {{error}}',
    toTracker: 'Создать задачи в трекере…',
    toTrackerTitle: 'Задачи из выделенного',
    toTrackerHint: 'Стикеры станут карточками, у каждой карточки появится задача. Дальше они меняются вместе: на доске и в трекере.',
    project: 'Проект',
    sprint: 'Спринт',
    toTrackerCreate_one: 'Создать {{count}} задачу',
    toTrackerCreate_few: 'Создать {{count}} задачи',
    toTrackerCreate_many: 'Создать {{count}} задач',
    toTrackerCreate_other: 'Создать {{count}} задачи',
    toTrackerDone_one: '{{count}} задача создана в «{{project}}»',
    toTrackerDone_few: '{{count}} задачи созданы в «{{project}}»',
    toTrackerDone_many: '{{count}} задач создано в «{{project}}»',
    toTrackerDone_other: '{{count}} задачи создано в «{{project}}»',
    toTrackerPartial_one: 'Успели создать {{count}} задачу.',
    toTrackerPartial_few: 'Успели создать {{count}} задачи.',
    toTrackerPartial_many: 'Успели создать {{count}} задач.',
    toTrackerPartial_other: 'Успели создать {{count}} задачи.',
    myTasks: 'Мои задачи',
    myTasksEmpty: 'На этой доске на вас пока ничего не назначено.',
    myTasksSignIn: 'Войдите, чтобы видеть свои задачи.',
  },
  props: {
    color: 'Цвет',
    fill: 'Заливка',
    stroke: 'Обводка',
    text: 'Текст',
    size: 'Размер',
    auto: 'Авто',
    align: 'Выравнивание',
    bold: 'Жирный',
    italic: 'Курсив',
    shape: 'Форма',
    lineStyle: 'Стиль линии',
    solid: 'Сплошная',
    dashed: 'Пунктир',
    dotted: 'Точки',
    width: 'Толщина',
    route: 'Тип линии',
    straight: 'Прямая',
    elbow: 'Ломаная',
    curve: 'Кривая',
    startCap: 'Начало',
    endCap: 'Конец',
    lock: 'Заблокировать',
    unlock: 'Разблокировать',
    front: 'На передний план',
    back: 'На задний план',
    duplicate: 'Дублировать',
    delete: 'Удалить',
    copy: 'Копировать',
    paste: 'Вставить',
    cut: 'Вырезать',
    alignLeft: 'По левому краю',
    alignCenter: 'По центру',
    alignRight: 'По правому краю',
    alignTop: 'По верху',
    alignMiddle: 'По середине',
    alignBottom: 'По низу',
    distributeH: 'Распределить по горизонтали',
    distributeV: 'Распределить по вертикали',
    arrange: 'Расположение',
    frameIt: 'Обернуть во фрейм',
    selectAll: 'Выделить всё',
    zoomTo: 'Приблизить к выделению',
    transparent: 'Без заливки',
    editText: 'Редактировать текст',
    addLabel: 'Добавить подпись',
    swap: 'Поменять концы',
  },
  palette: {
    inVatman: 'В Ватмане',
    placeholder: 'Команда или текст на доске…',
    noResults: 'Ничего не найдено',
    actions: 'Действия',
    onBoard: 'На доске',
    frames: 'Фреймы',
  },
  shortcutsGroups: {
    tools: 'Инструменты',
    edit: 'Редактирование',
    view: 'Вид',
    create: 'Быстрое создание',
    mindmap: 'Mind map',
  },
  shortcutsList: {
    pan: 'Двигать доску',
    zoom: 'Масштаб',
    fit: 'Показать всё',
    zoomSel: 'Приблизить к выделению',
    zoom100: 'Масштаб 100%',
    undo: 'Отменить',
    redo: 'Повторить',
    duplicate: 'Дублировать',
    group: 'Обернуть во фрейм',
    delete: 'Удалить',
    nudge: 'Сдвинуть на 1 / 10 px',
    edit: 'Редактировать текст',
    sibling: 'Связанный стикер в направлении',
    dblclick: 'Двойной клик — новый стикер',
    palette: 'Командная палитра',
    lock: 'Заблокировать',
    order: 'Наверх / вниз',
    selectAll: 'Выделить всё',
    nextSticky: 'Следующий стикер (при вводе текста)',
    mindChild: 'Подтема',
    mindSibling: 'Следующая тема',
    mindPromote: 'На уровень выше',
    mindCollapse: 'Свернуть / развернуть ветку',
    mindDelete: 'Удалить ветку',
    mindNavigate: 'Переход между темами',
    mindReorder: 'Поменять порядок тем',
    mindEdit: 'Редактировать текст (или просто начать печатать)',
  },
  mindmap: {
    new: 'Новая mind map',
    root: 'Центральная тема',
    addChild: 'Добавить подтему',
    collapse: 'Свернуть ветку',
    expand: 'Развернуть ветку',
    branchColor: 'Цвет ветки',
    copyMarkdown: 'Копировать как Markdown',
    copied: 'Структура скопирована в Markdown',
  },
  templates: {
    blank: 'Пустая доска',
    brainstorm: 'Мозговой штурм',
    retro: 'Ретроспектива',
    kanban: 'Канбан',
    mindmap: 'Mind map',
    swot: 'SWOT-анализ',
    journey: 'Путь клиента',
    content: {
      brainstormTopic: 'Главный вопрос',
      idea: 'Идея',
      retroGood: 'Что прошло хорошо',
      retroBad: 'Что можно улучшить',
      retroActions: 'Что сделаем',
      retroTitle: 'Ретроспектива спринта',
      backlog: 'Бэклог',
      todo: 'К работе',
      doing: 'В работе',
      review: 'На проверке',
      done: 'Готово',
      task: 'Задача',
      centralTopic: 'Центральная тема',
      branch: 'Ветка',
      strengths: 'Сильные стороны',
      weaknesses: 'Слабые стороны',
      opportunities: 'Возможности',
      threats: 'Угрозы',
      stages: ['Узнаёт', 'Изучает', 'Покупает', 'Пользуется', 'Рекомендует'],
      actions: 'Действия клиента',
      feelings: 'Эмоции',
      pains: 'Боли',
      ideas: 'Идеи улучшений',
    },
  },
  teamTemplates: {
    builtIn: 'Встроенные',
    tab: 'Шаблоны команды',
    saveBoard: 'Сохранить доску как шаблон',
    saveSelection: 'Сохранить выделение как шаблон',
    name: 'Название',
    namePlaceholder: 'Например, «Ретро нашей команды»',
    description: 'Описание',
    descriptionPlaceholder: 'Когда и как пользоваться шаблоном',
    category: 'Категория',
    scope: 'Кому доступен',
    teams: 'Команды',
    orgs: 'Организации',
    personal: 'Только мне (личное пространство)',
    wholeOrg: 'Вся организация «{{name}}»',
    items_one: '{{count}} объект',
    items_few: '{{count}} объекта',
    items_many: '{{count}} объектов',
    items_other: '{{count}} объекта',
    save: 'Сохранить шаблон',
    saved: 'Шаблон «{{name}}» сохранён',
    nothing: 'Нечего сохранять: доска пуста.',
    tooLarge: 'Слишком большой шаблон: не больше 5000 объектов и 2 МБ.',
    empty: 'Шаблонов пока нет. Сохраните доску или выделение через меню доски — шаблон появится здесь у всей команды.',
    noResults: 'Ничего не нашлось',
    search: 'Поиск шаблонов',
    all: 'Все',
    edit: 'Изменить',
    editTitle: 'Шаблон',
    delete: 'Удалить',
    deleteTitle: 'Удалить шаблон?',
    deleteConfirm: 'Шаблон «{{name}}» пропадёт у всех. Доски, созданные из него, останутся.',
    deleted: 'Шаблон удалён',
    by: 'Автор: {{name}}',
    loading: 'Загружаем шаблон…',
    categories: {
      retro: 'Ретро',
      planning: 'Планирование',
      research: 'Исследования',
      strategy: 'Стратегия',
      education: 'Обучение',
      other: 'Другое',
    },
  },
  comments: {
    refused: 'Сервер не принял изменение в комментариях. Комментарии загружены заново.',
    title: 'Комментарии',
    thread: 'Комментарий',
    placeholder: 'Напишите комментарий… @ — упомянуть',
    replyPlaceholder: 'Ответить…',
    send: 'Отправить',
    resolve: 'Отметить решённым',
    reopen: 'Открыть снова',
    resolvedBy: 'Решено: {{name}}',
    openTab: 'Открытые',
    resolvedTab: 'Решённые',
    deleteThread: 'Удалить обсуждение',
    deleteMessage: 'Удалить сообщение',
    replies_one: '{{count}} ответ',
    replies_few: '{{count}} ответа',
    replies_many: '{{count}} ответов',
    replies_other: '{{count}} ответа',
    show: 'Показывать комментарии на доске',
    hide: 'Скрыть комментарии с доски',
    empty: 'Комментариев пока нет. Нажмите C и кликните по доске, чтобы оставить комментарий.',
    emptyResolved: 'Решённых комментариев нет.',
    notified: 'Упомянутые получили уведомление: {{n}}',
    notFound: 'Комментарий не найден — возможно, его удалили.',
    noPeople: 'Никого не нашли',
    mentionsSignIn: 'Упоминать можно после входа в аккаунт',
    reply: 'Ответить',
    edit: 'Изменить',
    edited: 'изменено',
    editHint: 'Enter — сохранить, Esc — отменить',
    react: 'Реакция',
    deletedMessage: 'Сообщение удалено',
    imported: 'не в Ватмане',
  },
  timer: {
    title: 'Таймер',
    start: 'Запустить',
    pause: 'Пауза',
    resume: 'Продолжить',
    addMinute: '1 мин',
    reset: 'Сбросить',
    min: 'мин',
    custom: 'Своё время, мин',
    done: 'Время вышло',
    setBy: 'Запустил(а) {{name}}',
    onlyEditors: 'Таймером управляют редакторы доски.',
  },
  voting: {
    title: 'Голосование',
    start: 'Начать голосование',
    votesPerPerson: 'Голосов у каждого',
    startHint: 'Участники кликают по стикерам, чтобы отдать голос. Чужие голоса скрыты, пока голосование не закончится.',
    left: 'Осталось голосов: {{n}} из {{total}}',
    voted: 'Проголосовали: {{n}}',
    done: 'Готово',
    back: 'Изменить голоса',
    youDone: 'Вы проголосовали',
    end: 'Завершить',
    results: 'Результаты голосования',
    close: 'Закрыть голосование',
    finished: 'Голосование завершено',
    noLeft: 'Голоса закончились. Alt+клик по стикеру забирает голос.',
    takeBack: 'Забрать голос',
    summary: 'Участников: {{voters}} · голосов: {{votes}}',
    inProgress: 'Голосование ещё идёт. Результаты появятся, когда его завершат.',
    noResults: 'Голосований на этой доске пока не было.',
    noVotes: 'Никто не проголосовал.',
    emptySticky: 'Пустой стикер',
  },
  quickOpen: {
    button: 'Найти',
    title: 'Поиск по Ватману',
    placeholder: 'Задача, доска, проект или пространство — или ключ, например PAY-12',
    issues: 'Задачи',
    boards: 'Доски',
    projects: 'Проекты',
    spaces: 'Пространства',
    pages: 'Страницы',
    goTo: 'Перейти',
    inComment: 'в комментарии',
  },
  create: {
    title: 'Создать',
    board: 'Доска',
    page: 'Страница',
    issue: 'Задача',
    sprint: 'Спринт',
    startSprint: 'Начать спринт',
    project: 'Проект',
    space: 'Пространство',
    pick: { issue: 'Новая задача — в каком проекте?', sprint: 'Новый спринт — в каком проекте?', startSprint: 'Начать спринт — в каком проекте?' },
    noProjects: 'Здесь пока нет проектов, где вы можете это сделать.',
    findProject: 'Найти проект',
    alreadyRunning: 'Спринт «{{name}}» уже идёт',
  },
  docs: {
    titleLabel: 'Название',
    title: 'Документы',
    mode: { edit: 'Редактировать', done: 'Готово' },
    importHere: 'Импортировать сюда…',
    openOrigin: 'Открыть в Confluence',
    legacyNotFound: 'Страница не найдена',
    legacyNotFoundHint: 'Эту страницу ещё не перенесли из Confluence, или у вас нет к ней доступа.',
    legacyHome: 'На главную',
    labels: {
      title: 'Метки',
      find: 'Найти страницы с меткой «{{label}}»',
      remove: 'Убрать метку «{{label}}»',
      placeholder: 'Новая метка',
      add: 'Метка',
    },
    untitled: 'Без названия',
    notFound: 'Страница не найдена или недоступна',
    path: 'Где страница',
    offline: 'Нет связи: правки сохранятся и уйдут, когда сеть вернётся',
    addChild: 'Добавить страницу внутрь',
    linkCopied: 'Ссылка скопирована',
    copyLink: 'Скопировать ссылку',
    exportMarkdown: 'Скачать в Markdown',
    exportPdf: 'Скачать PDF',
    exportDocx: 'Скачать DOCX (Word)',
    exportBranchPdf: 'PDF со всеми вложенными',
    exportBranchDocx: 'DOCX со всеми вложенными',
    exportBranch: 'Скачать со всеми вложенными (ZIP)',
    print: 'Печать или PDF',
    delete: 'В корзину',
    deleted: 'Страница в корзине',
    inTrash: 'Страница в корзине.',
    trashedHint: 'Восстановите страницу, чтобы читать и править её.',
    deleteTitle: 'Удалить страницу?',
    deleteText: 'Страница уйдёт в корзину пространства; её можно восстановить 30 дней.',
    deleteWithChildren_one: 'Страница уйдёт в корзину вместе с {{count}} вложенной; их можно восстановить 30 дней.',
    deleteWithChildren_few: 'Страница уйдёт в корзину вместе с {{count}} вложенными; их можно восстановить 30 дней.',
    deleteWithChildren_many: 'Страница уйдёт в корзину вместе с {{count}} вложенными; их можно восстановить 30 дней.',
    deleteWithChildren_other: 'Страница уйдёт в корзину вместе с {{count}} вложенными; их можно восстановить 30 дней.',
    icon: 'Значок страницы',
    addIcon: 'Значок',
    removeIcon: 'Убрать значок',
    outline: 'На странице',
    edited: 'Изменил(а) {{who}}, {{when}}',
    empty: 'Здесь пока нет страниц',
    emptyHint: 'Страницы — для регламентов, решений, инструкций и всего, что команде нужно записать.',
    newPage: 'Новая страница',
    pagesUnder_one: '{{count}} страница внутри',
    pagesUnder_few: '{{count}} страницы внутри',
    pagesUnder_many: '{{count}} страниц внутри',
    pagesUnder_other: '{{count}} страницы внутри',
    trash_one: 'Корзина: {{count}} страница',
    trash_few: 'Корзина: {{count}} страницы',
    trash_many: 'Корзина: {{count}} страниц',
    trash_other: 'Корзина: {{count}} страницы',
    deletedBy: 'удалил(а) {{who}} {{when}}',
    noPages: 'Страниц пока нет',
    noChildren: 'Внутри пока нет страниц.',
    tocEmpty: 'Добавьте заголовки — они появятся здесь.',
    blocks: { childPages: 'Страницы внутри', toc: 'Оглавление', issueList: 'Задачи', board: 'Открыть доску' },
    callout: { change: 'Сменить вид плашки' },
    fileTooLarge: 'Файл «{{name}}» больше 25 МБ',
    uploading: 'Загружаю «{{name}}»…',
    placeholder: { heading: 'Заголовок', text: 'Пишите или нажмите «/» для блоков' },
    slash: {
      text: 'Текст',
      h1: 'Заголовок 1',
      h2: 'Заголовок 2',
      h3: 'Заголовок 3',
      bullet: 'Список',
      ordered: 'Нумерованный список',
      task: 'Чек-лист',
      quote: 'Цитата',
      callout: 'Плашка',
      details: 'Раскрывающийся блок',
      code: 'Код',
      table: 'Таблица',
      divider: 'Разделитель',
      file: 'Картинка или файл',
      toc: 'Оглавление',
      children: 'Страницы внутри',
      issues: 'Список задач',
      board: 'Доска',
      frame: 'Фрейм доски',
      nothing: 'Ничего не нашлось',
    },
    format: { bold: 'Жирный', italic: 'Курсив', underline: 'Подчёркнутый', strike: 'Зачёркнутый', code: 'Код', highlight: 'Выделить цветом', link: 'Ссылка' },
    comments: {
      title: 'Комментарии',
      add: 'Комментировать',
      onText: 'Комментарий к выделенному',
      onPage: 'Комментарий к странице',
      none: 'Пока нет обсуждений. Выделите текст, чтобы прокомментировать его.',
      resolved_one: 'Решено: {{count}}',
      resolved_few: 'Решено: {{count}}',
      resolved_many: 'Решено: {{count}}',
      resolved_other: 'Решено: {{count}}',
      resolve: 'Отметить решённым',
      reopen: 'Открыть снова',
    },
    history: {
      title: 'История версий',
      saved: 'Версия сохранена',
      restored: 'Версия восстановлена',
      namePlaceholder: 'Название версии, например «Согласовано»',
      save: 'Сохранить',
      none: 'Версий пока нет: они появляются после правок.',
      restore: 'Восстановить эту версию',
      reason: { review: 'На согласовании', approved: 'Согласовано' },
    },
    news: {
      title: 'Новости',
      new: 'Новая запись',
      draft: 'черновик',
      drafts_one: '{{count}} черновик',
      drafts_few: '{{count}} черновика',
      drafts_many: '{{count}} черновиков',
      drafts_other: '{{count}} черновика',
      empty: 'Новостей пока нет',
      emptyHint: 'Расскажите команде о релизе, решении или событии — участники пространства получат уведомление.',
      draftHint: 'Черновик: его видят автор и редакторы пространства. Участники узнают о записи после публикации.',
      publish: 'Опубликовать',
      published: 'Запись опубликована',
      publishedAt: 'Опубликовано {{date}}',
      unpublish: 'Снять с публикации',
      unpublished: 'Запись снова черновик',
    },
    filter: {
      all: 'Все',
      review: 'На согласовании',
      approved: 'Согласованные',
      none: { review: 'Сейчас ничего не согласуется.', approved: 'Согласованных страниц пока нет.' },
    },
    review: {
      menu: 'Отправить на согласование…',
      sendTitle: 'Отправить на согласование',
      sendHint: 'Согласующие получат уведомление и письмо. Согласованный текст сохранится в истории.',
      findPeople: 'Найти человека',
      rule: { all: 'Нужно согласие всех', any: 'Достаточно одного' },
      dueLabel: 'Срок (необязательно)',
      message: 'Сообщение согласующим',
      send_one: 'Отправить {{count}} человеку',
      send_few: 'Отправить {{count}} людям',
      send_many: 'Отправить {{count}} людям',
      send_other: 'Отправить {{count}} человека',
      sent: 'Страница отправлена на согласование',
      waiting: 'На согласовании у {{names}}',
      due: 'до {{date}}',
      anyOne: 'достаточно одного',
      sentBy: 'Отправил(а) {{name}}',
      approve: 'Согласовать',
      changes: 'Нужны правки',
      commentPlaceholder: 'Что поправить?',
      sendChanges: 'Отправить',
      sinceSent: 'Что изменилось с отправки',
      withdraw: 'Отозвать',
      changesNeeded: 'Нужны правки',
      sendAgain: 'Отправить снова',
      approved: 'Согласовано {{date}}',
      changedSince: 'Изменена после согласования {{date}}',
      whatChanged: 'Что изменилось',
      changesTitle: 'Что изменилось',
      badge: { review: 'На согласовании', changes: 'Нужны правки', approved: 'Согласовано', changed: 'Изменена после согласования' },
    },
    diff: {
      mode: { version: 'Версия', changes: 'Изменения', current: 'С текущей' },
      summary: 'Слов добавлено: {{added}} · удалено: {{removed}} · блоков затронуто: {{blocks}}',
      none: 'Изменений нет',
      count: 'Изменений: {{count}}',
      position: '{{at}} из {{count}}',
      previous: 'Предыдущее изменение',
      next: 'Следующее изменение',
    },
    access: {
      title: 'Доступ к странице',
      closed: 'Страница закрыта',
      inherited: 'Доступ задан на странице выше:',
      mode: { open: 'Как в пространстве', edit: 'Править — только выбранные', view: 'Видят — только выбранные' },
      hint: {
        open: 'Читают и правят все, кому это даёт пространство.',
        edit: 'Читают все в пространстве, правят только отмеченные.',
        view: 'Остальные в пространстве не видят страницу и всё, что под ней.',
      },
      whoReads: 'Кто видит',
      whoEdits: 'Кто правит',
      canEdit: 'правит',
      adminsNote: 'Администраторы пространства видят и правят любые страницы.',
    },
    templates: {
      start: 'Начать с шаблона',
      remove: 'Удалить шаблон',
      saved: 'Шаблон сохранён',
      saveTitle: 'Сохранить как шаблон',
      name: 'Название шаблона',
      description: 'Для чего он',
      for: 'Для кого',
      team: 'Команда',
      org: 'Вся организация',
    },
    backlinks_one: 'Ссылается {{count}} страница или задача',
    backlinks_few: 'Ссылаются {{count}} страницы или задачи',
    backlinks_many: 'Ссылаются {{count}} страниц или задач',
    backlinks_other: 'Ссылаются {{count}} страницы или задачи',
    links: { typeMore: 'Введите хотя бы две буквы', nothing: 'Ничего не нашлось' },
    issueList: {
      change: 'Изменить запрос',
      first_one: 'Показана {{count}} первая задача',
      first_few: 'Показаны {{count}} первые задачи',
      first_many: 'Показаны {{count}} первых задач',
      first_other: 'Показаны {{count}} первые задачи',
    },
    board: {
      pick: 'Выберите доску',
      noAccess: 'Доска недоступна',
      pickFrame: 'Выберите фрейм',
      noFrames: 'На доске нет фреймов — добавьте фрейм на доске.',
      frameGone: 'Фрейм удалён с доски',
      untitledFrame: 'Фрейм без названия',
      open: 'Открыть на доске',
    },
  },
  inbox: {
    title: 'Входящие',
    tab: { all: 'Все', unread: 'Непрочитанные', discussions: 'Обсуждения', issues: 'Задачи', access: 'Доступ' },
    deadlines: 'Сроки',
    allRead: 'Всё прочитано',
    emptyHint: 'Сюда приходят упоминания, комментарии и смена статуса ваших задач, назначения, сроки и приглашения.',
  },
  modules: {
    menu: 'Меню',
    label: 'Разделы',
    boards: 'Доски',
    tasks: 'Задачи',
  },
  docsImport: {
    title: 'Импорт документов',
    hint: 'Перенесите пространство Confluence, страницы Notion или архив Markdown — с картинками, ссылками и комментариями.',
    menu: 'Импорт документов…',
    fromConfluence: 'Импорт из Confluence или Markdown',
    source: {
      confluence_cloud: 'Confluence Cloud',
      confluence_server: 'Data Center',
      notion: 'Notion',
      markdown: 'Markdown',
    },
    url: 'Адрес Confluence',
    urlPlaceholder: {
      confluence_cloud: 'https://company.atlassian.net',
      confluence_server: 'https://wiki.company.ru',
    },
    tokenHelp: {
      confluence_cloud: 'API-токен создаётся на id.atlassian.com → Security → API tokens. Нужен доступ на чтение пространства.',
      confluence_server: 'Личный токен: аватар → Profile → Personal Access Tokens (Confluence 7.9 и новее).',
      notion: 'Создайте внутреннюю интеграцию на notion.so/profile/integrations (права: чтение контента, комментариев и сведений о людях с почтой), скопируйте её секрет и откройте интеграции доступ к нужным страницам: «…» → «Подключения».',
    },
    notionPick: 'Что перенести',
    notionNothing: 'Интеграции не открыта ни одна страница — добавьте её в «Подключения» нужных страниц.',
    database: 'база',
    markdownHint: 'Notion: Settings → Export → Markdown & CSV. Obsidian и GitHub Wiki: папка с файлами .md в ZIP. Папки станут вложенными страницами, картинки — файлами.',
    chooseZip: 'Выберите ZIP-архив',
    findSpace: 'Найти пространство',
    noSpaces: 'Пространств не нашлось — проверьте права токена.',
    under: 'Внутрь страницы «{{title}}»',
    again: 'Повторный импорт того же пространства догоняет изменения: обновит изменённые страницы и добавит новые, без дублей.',
    start: 'Начать импорт',
    reading: 'Читаем список страниц…',
    progress: 'Перенесено {{done}} из {{total}}',
    canClose: 'Окно можно закрыть — импорт продолжится, итог появится здесь же.',
    done: 'Готово',
    created_one: '{{count}} новая страница',
    created_few: '{{count}} новые страницы',
    created_many: '{{count}} новых страниц',
    created_other: '{{count}} новой страницы',
    updated_one: '{{count}} страница обновлена',
    updated_few: '{{count}} страницы обновлены',
    updated_many: '{{count}} страниц обновлено',
    updated_other: '{{count}} страницы обновлено',
    unchanged_one: '{{count}} страница без изменений',
    unchanged_few: '{{count}} страницы без изменений',
    unchanged_many: '{{count}} страниц без изменений',
    unchanged_other: '{{count}} страницы без изменений',
    files_one: '{{count}} файл',
    files_few: '{{count}} файла',
    files_many: '{{count}} файлов',
    files_other: '{{count}} файла',
    comments_one: '{{count}} комментарий',
    comments_few: '{{count}} комментария',
    comments_many: '{{count}} комментариев',
    comments_other: '{{count}} комментария',
    closed_one: '{{count}} страница закрыта, как была в Confluence',
    closed_few: '{{count}} страницы закрыты, как были в Confluence',
    closed_many: '{{count}} страниц закрыто, как были в Confluence',
    closed_other: '{{count}} страницы закрыто, как были в Confluence',
    keptDeleted_one: '{{count}} страница удалена здесь — оставили в корзине',
    keptDeleted_few: '{{count}} страницы удалены здесь — оставили в корзине',
    keptDeleted_many: '{{count}} страниц удалено здесь — оставили в корзине',
    keptDeleted_other: '{{count}} страницы удалено здесь — оставили в корзине',
    macros: 'Не перенесены макросы (на их месте плашка со ссылкой на оригинал):',
    unmatched: 'Не нашли здесь людей — они остались именами:',
    warnings_one: '{{count}} замечание',
    warnings_few: '{{count}} замечания',
    warnings_many: '{{count}} замечаний',
    warnings_other: '{{count}} замечания',
    open: 'Открыть',
  },
  trackerImport: {
    csvHint: 'Таблица из Яндекс Трекера, Kaiten, Trello, Jira или Excel: первая строка — заголовки. Колонки подберём по названиям, их можно поправить.',
    csvChoose: 'Выбрать файл .csv',
    csvRows_one: '{{count}} строка',
    csvRows_few: '{{count}} строки',
    csvRows_many: '{{count}} строк',
    csvRows_other: '{{count}} строки',
    csvKey: 'Ключ проекта',
    csvName: 'Название проекта',
    csvKeyHint: 'Задачи сохранят номера из колонки «Ключ» (OPS-12 станет OPS-12). Повторная загрузка той же таблицы обновит задачи, а не создаст копии.',
    csvField: {
      title: 'Название задачи',
      key: 'Ключ',
      description: 'Описание',
      status: 'Статус',
      type: 'Тип',
      priority: 'Приоритет',
      assignee: 'Исполнитель',
      reporter: 'Автор',
      labels: 'Метки',
      due: 'Срок',
      estimate: 'Оценка',
      created: 'Создана',
      parent: 'Родитель или эпик',
      sprint: 'Спринт',
    },
    worklogs_one: 'списаний времени: {{count}}',
    worklogs_few: 'списаний времени: {{count}}',
    worklogs_many: 'списаний времени: {{count}}',
    worklogs_other: 'списаний времени: {{count}}',
    entry: 'Импорт из Jira и других',
    title: 'Импорт задач',
    hint: 'Проект переедет с теми же ключами и номерами задач. Токен нужен только на время импорта и нигде не сохраняется.',
    system: { jira_cloud: 'Jira Cloud', jira_server: 'Jira Data Center', youtrack: 'YouTrack', yandex_tracker: 'Яндекс Трекер', kaiten: 'Kaiten', trello: 'Trello', csv: 'CSV-файл' },
    url: 'Адрес',
    urlPlaceholder: { jira_cloud: 'company.atlassian.net', jira_server: 'https://jira.company.ru', youtrack: 'https://company.youtrack.cloud', yandex_tracker: '', kaiten: 'https://company.kaiten.ru', trello: '' },
    email: 'Почта аккаунта Atlassian',
    orgId: 'ID организации',
    trelloKey: 'API-ключ',
    token: 'Токен',
    tokenHelp: {
      jira_cloud: 'API-токен: id.atlassian.com → Безопасность → API-токены. Хватит прав на чтение проекта.',
      jira_server: 'Personal Access Token: профиль в Jira → Personal Access Tokens.',
      youtrack: 'Permanent token: профиль в YouTrack → Account Security → Tokens, доступ к YouTrack.',
      yandex_tracker: 'OAuth-токен с правом tracker:read (oauth.yandex.ru) или IAM-токен. ID организации — в Трекере: Администрирование → Организации; цифры для Яндекс 360, иначе организация Yandex Cloud.',
      kaiten: 'API-ключ: профиль в Kaiten → API-ключ (адрес /profile/api-key). Переносятся доски: колонки, карточки, комментарии и списания; номера задач выдаются по порядку.',
      trello: 'API-ключ и токен: trello.com/power-ups/admin → ваш Power-Up → API key, затем ссылка «Token». Почты людей Trello не отдаёт — совпадение по имени.',
    },
    connect: 'Подключиться',
    findProject: 'Найти проект',
    noProjects: 'Проектов не нашлось.',
    team: 'В какую команду',
    next: 'Дальше',
    issuesCount_one: '{{count}} задача',
    issuesCount_few: '{{count}} задачи',
    issuesCount_many: '{{count}} задач',
    issuesCount_other: '{{count}} задачи',
    keyState: {
      newNumbered: 'Появится новый проект {{key}}, задачи получат номера по порядку и сохранят их при повторном импорте.',
      new: 'Появится новый проект {{key}}, задачи сохранят свои номера.',
      again: 'Проект {{key}} уже переносили: обновим изменённые задачи и добавим новые, дублей не будет.',
      empty: 'Задачи лягут в пустой проект {{key}}, который уже есть в команде.',
      taken: 'Ключ {{key}} занят другим проектом с задачами. Переименуйте его ключ или выберите другую команду.',
    },
    statuses: 'Статусы',
    peopleMatched: 'Нашлись в команде',
    peopleUnmatched: 'Нет в команде',
    unmatchedHint: 'Их задачи останутся без исполнителя, имя из исходной системы будет видно в задаче. Пригласите людей в команду — и повторный импорт назначит задачи.',
    start: 'Перенести',
    catchUp: 'Докачать изменения',
    progress: 'Перенесено {{done}} из {{total}}',
    phase: { start: 'Подключаемся…', statuses: 'Переносим статусы…', issues: 'Переносим задачи…', links: 'Связываем задачи…' },
    canClose: 'Окно можно закрыть — импорт продолжится.',
    done: 'Готово: проект {{key}} в Ватмане.',
    created_one: 'новых задач: {{count}}',
    created_few: 'новых задач: {{count}}',
    created_many: 'новых задач: {{count}}',
    created_other: 'новых задач: {{count}}',
    updated_one: 'обновлено: {{count}}',
    updated_few: 'обновлено: {{count}}',
    updated_many: 'обновлено: {{count}}',
    updated_other: 'обновлено: {{count}}',
    comments_one: 'комментариев: {{count}}',
    comments_few: 'комментариев: {{count}}',
    comments_many: 'комментариев: {{count}}',
    comments_other: 'комментариев: {{count}}',
    sprints_one: 'спринтов: {{count}}',
    sprints_few: 'спринтов: {{count}}',
    sprints_many: 'спринтов: {{count}}',
    sprints_other: 'спринтов: {{count}}',
    unmatchedDone: 'Не нашлись в команде:',
    skipped_one: 'Пропущена {{count}} задача:',
    skipped_few: 'Пропущены {{count}} задачи:',
    skipped_many: 'Пропущено {{count}} задач:',
    skipped_other: 'Пропущено {{count}} задачи:',
    reason: { number_taken: 'номер уже занят задачей, созданной в Ватмане', deleted_here: 'удалена в Ватмане' },
    files: 'Перенести файлы задач',
    filesHint: 'до 50 МБ каждый; это дольше',
    links_one: 'связей: {{count}}',
    links_few: 'связей: {{count}}',
    links_many: 'связей: {{count}}',
    links_other: 'связей: {{count}}',
    attachments_one: 'файлов: {{count}}',
    attachments_few: 'файлов: {{count}}',
    attachments_many: 'файлов: {{count}}',
    attachments_other: 'файлов: {{count}}',
    attachmentsSkipped_one: 'Не перенесён {{count}} файл: больше 50 МБ или система его не отдала. Он остался там.',
    attachmentsSkipped_few: 'Не перенесены {{count}} файла: больше 50 МБ или система их не отдала. Они остались там.',
    attachmentsSkipped_many: 'Не перенесено {{count}} файлов: больше 50 МБ или система их не отдала. Они остались там.',
    attachmentsSkipped_other: 'Не перенесено {{count}} файла: больше 50 МБ или система их не отдала. Они остались там.',
    openProject: 'Открыть проект',
  },
  teams: {
    nameTitle: 'Название команды',
    renameTitle: 'Переименовать команду',
    renamed: 'Команда переименована',
    delete: 'Удалить команду',
    deleteHint: 'Удалить можно только пустую команду: без своих проектов, досок (и в корзине тоже), страниц, спринтов, агентов, шаблонов и общих фильтров, с одним пустым основным пространством. Из чужих проектов команда уйдёт, её задачи там вернутся основным командам. Последнюю команду организации удалить нельзя.',
    deleteConfirm: 'Удалить команду «{{name}}»? Это нельзя отменить.',
    deleted: 'Команда «{{name}}» удалена',
    backlogAll: 'Все задачи проектов команды',
    backlogOwn: 'Только задачи команды',
    sprintsOf: 'Спринты — общие для всех проектов команды:',
    mine: 'Мои спринты',
    tab: { board: 'Доска спринта', backlog: 'Бэклог и спринты', reports: 'Отчёты', projects: 'Проекты', people: 'Люди', settings: 'Настройки' },
    noProjects: 'Команда пока не работает ни в одном проекте',
    noProjectsHint: 'Создайте проект в пространстве команды или попросите администратора проекта добавить команду в его настройках.',
    sharedBy: 'проект команды «{{team}}»',
    own: 'проект команды',
    sprints: 'Спринты',
    parallel: 'Несколько спринтов одновременно',
    parallelHint: 'Обычно у команды идёт один спринт. Включите, если команда ведёт параллельные спринты — например, по разным направлениям.',
  },
  tracker: {
    alsoTeams: 'Также работают в проекте',
    allTeams: 'Все команды',
    alsoTeamsHint: 'Их люди получат роль участника, а задачи проекта появятся в их бэклогах. Команды можно поменять в настройках проекта.',
    quickProject: 'Проект новой задачи',
    noTeam: 'Без команды',
    linkHint: 'Начните вводить название задачи, доски или проекта',
    linkNothing: 'Ничего не нашлось',
    noDescription: 'Описания нет',
    alsoEditing: 'Сейчас правит: {{names}}',
    customFields: 'Поля из {{system}} ({{count}})',
    time: {
      title: 'Время',
      log: 'Списать время',
      logN: 'Списать {{time}}',
      spent: 'Затрачено {{spent}}',
      spentOf: 'Затрачено {{spent}} из {{estimate}}',
      placeholder: '1ч 30м',
      howLong: 'Сколько',
      day: 'День',
      note: 'Что сделано (необязательно)',
      remove: 'Удалить списание',
      person: 'Кто',
      total: 'Итого',
      prevWeek: 'Предыдущая неделя',
      nextWeek: 'Следующая неделя',
      thisWeek: 'Эта неделя',
      empty: 'За эту неделю время не списывали.',
      history: { added: 'списывает {{time}} за {{day}}', changed: 'меняет списание: {{time}} за {{day}}', removed: 'удаляет списание {{time}} за {{day}}' },
    },
    lanes: {
      title: 'Дорожки',
      project: 'проект',
      none: 'нет',
      assignee: 'исполнитель',
      epic: 'эпик',
      priority: 'приоритет',
      unassigned: 'Без исполнителя',
      noEpic: 'Без эпика',
      activeSprint: 'Только спринт «{{name}}»',
      ofLimit: '{{count}} из {{limit}}',
      overLimit: 'Больше лимита: {{limit}}',
    },
    myIssues: 'Мои задачи',
    projects: 'Проекты',
    otherTeams: 'Другие команды',
    newProject: 'Новый проект',
    newProjectHint: 'Проект — это набор задач со своим ключом, статусами и спринтами.',
    firstProject: 'Создать первый проект',
    projectName: 'Название',
    projectNamePlaceholder: 'Например, Платежи',
    projectKey: 'Ключ',
    team: 'Команда',
    keyHint: 'Ключ стоит в номере каждой задачи: {{example}}. Латиница и цифры, до 10 символов.',
    onBoards: 'На досках',
    issueNotFound: 'Задача не найдена или у вас нет к ней доступа.',
    toPage: 'Открыть на всю страницу',
    toPanel: 'Вернуть в колонку проекта',
    keyChoices: '{{key}} есть в нескольких ваших организациях — какую открыть?',
    preset: { assigned: 'Назначены мне', reported: 'Созданы мной', open: 'Все открытые' },
    view: { board: 'Доска', list: 'Список', backlog: 'Бэклог и спринты', reports: 'Отчёты', time: 'Время', settings: 'Настройки' },
    reports: {
      none: 'Отчёты появятся, когда начнётся первый спринт.',
      committed_one: 'обещано: {{count}} задача',
      committed_few: 'обещано: {{count}} задачи',
      committed_many: 'обещано: {{count}} задач',
      committed_other: 'обещано: {{count}} задачи',
      added_one: 'добавлена по ходу: {{count}}',
      added_few: 'добавлено по ходу: {{count}}',
      added_many: 'добавлено по ходу: {{count}}',
      added_other: 'добавлено по ходу: {{count}}',
      removed_one: 'убрана: {{count}}',
      removed_few: 'убрано: {{count}}',
      removed_many: 'убрано: {{count}}',
      removed_other: 'убрано: {{count}}',
      done_one: 'сделана: {{count}}',
      done_few: 'сделано: {{count}}',
      done_many: 'сделано: {{count}}',
      done_other: 'сделано: {{count}}',
      notDone_one: 'не сделана: {{count}}',
      notDone_few: 'не сделано: {{count}}',
      notDone_many: 'не сделано: {{count}}',
      notDone_other: 'не сделано: {{count}}',
      burndown: 'Burndown: сколько осталось',
      velocity: 'Скорость команды',
      noVelocity: 'Скорость появится после первого завершённого спринта.',
      committedLegend: 'обещано',
      doneLegend: 'сделано',
      average: 'в среднем {{value}} {{unit}} за спринт',
      list: { done: 'Сделано', notDone: 'Не сделано', added: 'Добавлено по ходу', removed: 'Убрано из спринта' },
    },
    queryPlaceholder: 'статус: открыта исполнитель: я #срочно',
    queryHelp:
      'Поля: статус, исполнитель, автор, приоритет, тип, метка, спринт, срок, создана, обновлена, проект.\nЗначения: я, нет, открыта, решена, сегодня, -7д.\n#метка или #приоритет — коротко. -поле: значение — исключить.\nсорт: приоритет, срок, обновлена. Обычные слова ищут в названии, описании и комментариях.',
    queryWarnings: 'Не понял: {{list}}',
    newIssue: 'Задача',
    newIssueIn: 'Новая задача в «{{project}}»',
    titlePlaceholder: 'Что нужно сделать?',
    createMore: 'Создать ещё',
    created: '{{key}} создана',
    unassigned: 'Не назначена',
    nobody: 'никто',
    someone: 'Кто-то',
    backlog: 'Бэклог',
    sprintActive: 'Идёт',
    copyLink: 'Скопировать ссылку',
    linkCopied: 'Ссылка скопирована',
    delete: 'Удалить задачу',
    deleted: '{{key}} удалена',
    comments: 'Комментарии',
    history: 'История',
    createdUpdated: 'Создана {{created}} · обновлена {{updated}}',
    descriptionPlaceholder: 'Описание, критерии готовности, ссылки на доски…',
    estimatePlaceholder: 'например, 2ч 30м',
    addLabel: 'Добавить метку',
    noComments: 'Комментариев пока нет.',
    commentPlaceholder: 'Комментарий… @ — упомянуть, Enter — отправить',
    send: 'Отправить',
    importedFrom: 'Перенесено из {{system}}:',
    assigneeThere: 'исполнитель там — {{name}}',
    system: { jira: 'Jira', youtrack: 'YouTrack', yandex: 'Яндекс Трекера', kaiten: 'Kaiten', trello: 'Trello', csv: 'таблицы' },
    historyImported: 'переносит задачу из {{system}}',
    notHere: 'не в команде',
    historyCreated: 'создаёт задачу',
    historyDeleted: 'удаляет задачу',
    historyDescription: 'меняет описание',
    historyChanged: 'меняет поле «{{field}}»:',
    field: {
      status: 'Статус',
      team: 'Команда',
      assignee: 'Исполнитель',
      priority: 'Приоритет',
      priorityShort: 'Пр.',
      type: 'Тип',
      sprint: 'Спринт',
      due: 'Срок',
      estimate: 'Оценка',
      points: 'Story points',
      labels: 'Метки',
      key: 'Ключ',
      title: 'Название',
      updated: 'Обновлена',
      parent: 'Родитель',
    },
    command: {
      open: 'Командная строка',
      button: 'Команда',
      placeholder: 'статус: в работе исполнитель: я срок: завтра оценка: 2ч',
      placeholderBulk: 'статус: готово исполнитель: я метка: +срочно',
      hint: 'Поля как в поиске: статус, исполнитель, приоритет, тип, спринт, метка (+добавить, -убрать), срок (завтра, +3д, 1.11), оценка (2ч 30м); «нет» очищает. Слова «взять», «закрыть», «открыть», «я», #метка. Enter — применить, Esc — закрыть.',
      apply: 'Применить (Enter)',
      me: 'я',
      clear: 'убрать',
      oneOnly: 'только для одной задачи',
      notInBulk: 'Для нескольких задач сразу это поле не меняется',
      applied_one: 'Изменена {{count}} задача',
      applied_few: 'Изменены {{count}} задачи',
      applied_many: 'Изменено {{count}} задач',
      applied_other: 'Изменено {{count}} задачи',
      error: {
        field: 'нет поля «{{text}}»',
        status: 'нет статуса «{{text}}»',
        person: 'нет участника «{{text}}»',
        ambiguous: '«{{text}}» — уточните, подходят несколько',
        priority: 'нет приоритета «{{text}}»',
        type: 'нет типа «{{text}}»',
        sprint: 'нет открытого спринта «{{text}}»',
        team: 'у проекта нет команды «{{text}}»',
        date: 'не понял дату «{{text}}»',
        estimate: 'не понял оценку «{{text}}»',
        points: 'Story points — число от 0 до 1000, а не «{{text}}»',
        word: 'не понял «{{text}}»',
      },
    },
    priority: { 0: 'Критичный', 1: 'Высокий', 2: 'Обычный', 3: 'Низкий' },
    type: { task: 'Задача', bug: 'Ошибка', story: 'История', epic: 'Эпик', subtask: 'Подзадача' },
    units: { d: 'д', h: 'ч', m: 'м', b: 'Б', kb: 'КБ', mb: 'МБ', gb: 'ГБ' },
    addIssue: 'Добавить задачу',
    quickPlaceholder: 'Название и Enter (Shift+Enter — ещё одна)',
    noIssues: 'Задач по этому запросу нет.',
    issuesCount_one: '{{count}} задача',
    issuesCount_few: '{{count}} задачи',
    issuesCount_many: '{{count}} задач',
    issuesCount_other: '{{count}} задачи',
    doneOf: 'готово {{done}} из {{total}}',
    startSprint: 'Начать спринт',
    closeSprint: 'Завершить',
    newSprint: 'Спринт',
    newSprintTitle: 'Новый спринт',
    sprintEmpty: 'Перетащите сюда задачи из бэклога.',
    backlogEmpty: 'Бэклог пуст.',
    sprintN: 'Спринт {{n}}',
    sprintName: 'Название',
    sprintGoal: 'Цель спринта',
    sprintStarts: 'Начало',
    sprintEnds: 'Конец',
    sp: 'SP',
    storyPoints: 'Story points',
    sprints: {
      edit: 'Изменить спринт',
      editTitle: 'Спринт',
      startTitle: 'Начать «{{name}}»',
      goalHint: 'Что команда хочет получить к концу спринта',
      length: 'Длительность',
      weeks_one: '{{count}} неделя',
      weeks_few: '{{count}} недели',
      weeks_many: '{{count}} недель',
      weeks_other: '{{count}} недели',
      customDates: 'Свои даты',
      capacityPoints: 'Ёмкость, SP',
      capacityHours: 'Ёмкость, часов',
      capacityHint: 'Сколько команда берёт в спринт — необязательно',
      capacityOf: 'взято {{load}} из {{capacity}} {{unit}}',
      hoursShort: 'ч',
      moveUp: 'Выше',
      moveDown: 'Ниже',
      delete: 'Удалить спринт',
      deleteConfirm: 'Удалить спринт «{{name}}»? Его задачи вернутся в бэклог.',
      completeTitle: 'Завершить «{{name}}»',
      complete: 'Завершить спринт',
      issuesDone: 'задач готово',
      pointsDone: 'SP готово',
      openGoTo_one: 'Незавершённая задача ({{count}}) — куда перенести?',
      openGoTo_few: 'Незавершённые задачи ({{count}}) — куда перенести?',
      openGoTo_many: 'Незавершённые задачи ({{count}}) — куда перенести?',
      openGoTo_other: 'Незавершённые задачи ({{count}}) — куда перенести?',
      toBacklog: 'В бэклог',
      toNewSprint: 'В новый спринт',
      allDone: 'Все задачи спринта готовы.',
      closed: 'Спринт «{{name}}» завершён',
      daysLeft_one: 'осталось {{count}} день',
      daysLeft_few: 'осталось {{count}} дня',
      daysLeft_many: 'осталось {{count}} дней',
      daysLeft_other: 'осталось {{count}} дня',
      lastDay: 'последний день',
      overdue_one: 'срок вышел {{count}} день назад',
      overdue_few: 'срок вышел {{count}} дня назад',
      overdue_many: 'срок вышел {{count}} дней назад',
      overdue_other: 'срок вышел {{count}} дня назад',
      planned: 'Запланирован',
      pointsProgress: 'Готово {{done}} из {{total}} SP',
      pointsHint: 'например, 3',
      boardShows: 'Спринт',
      current: 'Текущий: {{name}}',
      currentAll_one: 'Идущий спринт',
      currentAll_few: 'Идущие спринты ({{count}})',
      currentAll_many: 'Идущие спринты ({{count}})',
      currentAll_other: 'Идущие спринты ({{count}})',
      allIssues: 'Все задачи',
      byPeople: 'По людям',
      load: 'Нагрузка в спринте',
      openOf: 'открыто {{open}} из {{total}}',
      picked_one: 'Выбрана {{count}} задача — перетащите любую из них',
      picked_few: 'Выбрано {{count}} задачи — перетащите любую из них',
      picked_many: 'Выбрано {{count}} задач — перетащите любую из них',
      picked_other: 'Выбрано {{count}} задачи — перетащите любую из них',
      unpick: 'Снять выбор',
      startNew: 'Новый спринт — сразу в работу',
      newOption: '+ Новый спринт',
      noneRunning: 'Спринт не идёт.',
      nextIs: 'Следующий — «{{name}}».',
      whatIs: 'Спринт — задачи на 1–4 недели с целью и сроком.',
      create: 'Создать спринт',
      planInBacklog: 'Спланировать в бэклоге',
      hideBanner: 'Не показывать: мы работаем без спринтов',
    },
    noPeople: 'Никого не нашли',
    links: {
      title: 'Связи',
      add: 'Связь',
      remove: 'Убрать связь с {{key}}',
      kind: 'Тип связи',
      searchPlaceholder: 'Ключ или название задачи',
      already: 'уже связана',
      blocked: 'Заблокирована',
      blockedBy: 'Заблокирована, ждёт:',
      rel: { blocks: 'Блокирует', blocked_by: 'Заблокирована', relates: 'Связана с', duplicates: 'Дублирует', duplicated_by: 'Дублируется' },
      historyAdded: 'добавляет связь: {{relation}} {{key}}',
      historyRemoved: 'убирает связь: {{relation}} {{key}}',
    },
    files: {
      title: 'Файлы',
      attach: 'Прикрепить',
      hint: 'Перетащите файлы сюда или вставьте скриншот из буфера. До 25 МБ каждый.',
      drop: 'Отпустите, чтобы прикрепить',
      tooLarge: '«{{name}}» больше 25 МБ — такой файл не прикрепить.',
      download: 'Скачать',
      remove: 'Удалить файл',
      removed: 'Файл «{{name}}» удалён',
      open: 'Открыть «{{name}}»',
      historyAdded: 'прикрепляет файл «{{name}}»',
      historyRemoved: 'удаляет файл «{{name}}»',
    },
    filters: {
      empty: 'Сохранённых фильтров нет',
      emptyHint: 'Найдите задачи запросом и нажмите «Сохранить» рядом с ним — фильтр появится здесь.',
      subscribe: 'Подписаться',
      subscribed: 'Задачи фильтра будут приходить на почту: {{when}}',
      unsubscribed: 'Письма по фильтру отключены',
      digestHint: 'Задачи фильтра на почту, в 9:00 по Москве',
      digest: { daily: 'каждое утро', weekly: 'по понедельникам', off: 'не присылать' },
      title: 'Фильтры',
      save: 'Сохранить',
      saveHint: 'Сохранить запрос как фильтр — он появится в «Моих задачах» на вкладке «Фильтры»',
      saveTitle: 'Сохранить фильтр',
      name: 'Название',
      namePlaceholder: 'Например, Баги релиза',
      saveButton: 'Сохранить',
      share: 'Показать команде',
      shareWith: 'Показать команде «{{team}}»',
      shareHint: 'каждый увидит в нём только доступные ему задачи',
      unshare: 'Оставить только себе',
      inProject: 'в проекте {{key}}',
      everywhere: 'во всех проектах',
      sharedWith: 'общий для «{{team}}»',
      private: 'виден только вам',
      by: 'автор — {{name}}',
      reset: 'Сбросить',
      saveChanges: 'Сохранить изменения',
      saved: 'Фильтр сохранён',
      delete: 'Удалить фильтр',
      deleteTitle: 'Удалить фильтр «{{name}}»?',
      deleteShared: 'Он пропадёт у всей команды. Задачи останутся.',
      deleted: 'Фильтр «{{name}}» удалён',
    },
    bulk: {
      toolbar: 'Действия с выбранными задачами',
      selectAll: 'Выбрать все',
      select: 'Выбрать {{key}}',
      selected_one: 'Выбрана {{count}}',
      selected_few: 'Выбрано {{count}}',
      selected_many: 'Выбрано {{count}}',
      selected_other: 'Выбрано {{count}}',
      noCommonStatuses: 'У проектов выбранных задач нет общих статусов',
      sprintOneProject: 'Спринт — только для задач одного проекта',
      addLabel: 'Добавить метку и Enter',
      removeLabel: 'Убрать метку',
      delete: 'Удалить выбранные',
      deleteTitle_one: 'Удалить {{count}} задачу?',
      deleteTitle_few: 'Удалить {{count}} задачи?',
      deleteTitle_many: 'Удалить {{count}} задач?',
      deleteTitle_other: 'Удалить {{count}} задачи?',
      deleteHint: 'Задачи пропадут из списков и с досок, но останутся в истории проекта.',
      deleteConfirm: 'Удалить',
      clear: 'Снять выделение',
      done_one: 'Изменена {{count}} задача',
      done_few: 'Изменены {{count}} задачи',
      done_many: 'Изменено {{count}} задач',
      done_other: 'Изменено {{count}} задачи',
      partly: 'Изменено: {{changed}}, не получилось: {{failed}}. {{reasons}} Они остались выбранными.',
    },
    dev: {
      title: 'Разработка',
      pr: { open: 'открыт', draft: 'черновик', merged: 'влит', closed: 'закрыт' },
      ci: { pending: 'CI: в очереди', running: 'CI: идёт', success: 'CI: успешно', failed: 'CI: упал', canceled: 'CI: отменён' },
      moreCommits_one: 'ещё {{count}} коммит',
      moreCommits_few: 'ещё {{count}} коммита',
      moreCommits_many: 'ещё {{count}} коммитов',
      moreCommits_other: 'ещё {{count}} коммита',
      fewer: 'свернуть',
      closedBy: 'закрывает задачу изменением',
      notClosed: 'не закрывает задачу изменением',
    },
    git: {
      title: 'Git',
      hint: 'Ключ задачи ({{example}}) в названии ветки, коммита или pull request связывает их с задачей — в любом проекте команды. В задаче видны состояние и CI.',
      provider: { github: 'GitHub', gitlab: 'GitLab', gitea: 'Gitea / Forgejo', bitbucket: 'Bitbucket' },
      connect: 'Подключить репозиторий',
      connectTitle: 'Подключить репозиторий',
      connectHint: 'Дальше Ватман покажет адрес вебхука и секрет — их нужно вставить в настройки репозитория.',
      url: 'Адрес репозитория',
      urlPlaceholder: { github: 'https://github.com/команда/проект', gitlab: 'https://gitlab.com/группа/проект', gitea: 'https://git.example.ru/команда/проект', bitbucket: 'https://bitbucket.org/команда/проект' },
      setup: 'Настройка',
      noEvents: 'вебхук ещё не приходил',
      lastEvent: 'последнее событие {{when}}: {{event}}',
      linked_one: 'связан с {{count}} задачей',
      linked_few: 'связан с {{count}} задачами',
      linked_many: 'связан с {{count}} задачами',
      linked_other: 'связан с {{count}} задачами',
      hookUrl: 'Адрес вебхука (Payload URL)',
      secret: 'Секрет (Secret)',
      token: 'Секретный токен (Secret token)',
      autoClose: 'Закрывать задачи слиянием',
      autoCloseHint: '«Fixes {{example}}» или «закрывает {{example}}» в слитом pull request или коммите основной ветки переводит задачу в «Готово» по правилам проекта',
      rotate: 'Новый секрет',
      disconnect: 'Отключить',
      steps: {
        github: 'В репозитории: Settings → Webhooks → Add webhook. Payload URL и Secret — ниже, Content type — application/json. События: «Let me select individual events» → Pushes, Pull requests, Branch or tag creation и deletion, Statuses, Check suites, Workflow runs.',
        gitlab: 'В проекте: Settings → Webhooks → Add new webhook. URL и Secret token — ниже. Триггеры: Push events, Merge request events, Pipeline events.',
        gitea: 'В репозитории: Settings → Webhooks → Add webhook → Gitea (или Forgejo). Target URL и Secret — ниже, POST, application/json. События: Push, Pull request, Create и Delete; для CI — Status, если ваша версия его отправляет.',
        bitbucket: 'Bitbucket Cloud: Repository settings → Webhooks → Add webhook, URL и Secret — ниже, триггеры: Push, Pull request (Created, Updated, Merged, Declined), Build status (Created, Updated). Data Center: Repository settings → Webhooks → Create webhook, URL и Secret — ниже, события: Repository → Push, Pull request → Opened, Modified, Merged, Declined. В Data Center в задаче видны ветки и pull request, коммиты — нет.',
      },
    },
    watch: { start: 'Следить за задачей: комментарии и смена статуса придут во входящие и на почту', stop: 'Перестать следить', who: 'Следят: {{names}}' },
  },
  trackerSettings: {
    teams: {
      title: 'Команды',
      hint: 'Команды организации, которые работают в проекте. Их люди получают роль в проекте, а у задач появляется поле «Команда». Пространство основной команды при этом не открывается.',
      home: 'основная команда: пространство и настройки проекта',
      role: 'Роль команды {{name}}',
      roles: { member: 'Работает в проекте', viewer: 'Только читает' },
      add: 'Добавить команду',
      pick: 'Выберите команду…',
      none: 'Других команд в организации нет',
      remove: 'Убрать команду из проекта: её задачи перейдут основной команде',
    },
    estimation: 'Чем оценивать задачи',
    estimationTime: 'Временем (часы и минуты)',
    estimationHint: 'Story points — относительный размер задачи (1, 2, 3, 5, 8…); по ним считаются ёмкость спринта, burndown и скорость. Учёт потраченного времени работает в обоих случаях.',
    orgAccess: {
      title: 'Доступ организации',
      label: 'Все в организации «{{name}}»',
      hint: 'Что могут в проекте люди организации, которые не входят в команду. С правом редактирования они ведут задачи и могут быть исполнителями.',
    },
    members: {
      title: 'Участники и роли',
      hint: 'По умолчанию в проекте работает его команда: владельцы и администраторы команды им управляют, участники ведут задачи. Здесь можно дать человеку другую роль или позвать коллегу из организации.',
      fromOrg: 'из организации',
      guest: 'гость',
      invite: 'Пригласить',
      invitePlaceholder: 'Почта коллеги или гостя',
      inviteHint: 'Человек со стороны станет гостем: увидит только этот проект. Если у него нет аккаунта, придёт письмо со ссылкой.',
      invitedAdded: '{{email}} добавлен(а) в проект',
      invitedSent: 'Приглашение отправлено на {{email}}',
      pending: 'ждёт ответа',
      cancelInvite: 'Отменить приглашение',
      teamAdmin: 'администратор команды',
      role: 'Роль: {{name}}',
      reset: 'Вернуть роль из команды',
      remove: 'Убрать из проекта',
      add: 'Добавить человека из организации',
      search: 'Имя или почта',
      newRole: 'Роль нового участника',
      nobody: 'Никого не нашлось',
      roles: { admin: 'Администратор', member: 'Участник', viewer: 'Наблюдатель', reporter: 'Автор заявок' },
      about: {
        admin: 'настройки, статусы, роли',
        member: 'создаёт и ведёт задачи, списывает время',
        viewer: 'видит задачи и доску, ничего не меняет',
        reporter: 'заводит задачи и комментирует, остальное делает команда',
      },
    },
    wipLimit: 'Лимит задач в колонке (WIP)',
    wipNone: 'без лимита',
    general: 'Проект',
    description: 'Описание',
    descriptionPlaceholder: 'О чём проект, ссылки на доски и документы',
    statuses: 'Статусы',
    statusesHint: 'Колонки доски по порядку. Категория решает, открыта задача или готова; правила — откуда можно перейти в статус и что к этому моменту должно быть заполнено.',
    move: 'Переместить «{{name}}»',
    moveHint: 'Перетащите или нажмите ↑ / ↓',
    color: 'Цвет',
    statusName: 'Название статуса',
    category: 'Категория',
    cat: { todo: 'К работе', doing: 'В работе', done: 'Готово' },
    rules: 'Правила',
    rulesN_one: '{{count}} правило',
    rulesN_few: '{{count}} правила',
    rulesN_many: '{{count}} правил',
    rulesN_other: '{{count}} правила',
    deleteStatus: 'Удалить статус «{{name}}»',
    allowedFrom: 'Перейти в «{{name}}» можно',
    fromAny: 'из любого статуса',
    fromSome: 'только из выбранных',
    fromNone: 'Ни один статус не выбран — перейти сюда будет нельзя.',
    required: 'К переходу должно быть заполнено',
    field: { assignee: 'Исполнитель', estimate: 'Оценка', due: 'Срок', description: 'Описание', labels: 'Метки', sprint: 'Спринт' },
    deleteTitle: 'Удалить статус «{{name}}»?',
    deleteHint: 'Задачи из него перейдут в другой статус, а правила других статусов перестанут его упоминать.',
    moveTo: 'Перенести задачи в',
    deleteHistory: 'Перенос попадёт в историю каждой задачи {{key}}.',
    deleteConfirm: 'Удалить статус',
    deleted: 'Статус «{{name}}» удалён',
    newStatus: 'Новый статус',
    addStatus: 'Добавить',
    archive: 'Архив',
    archiveHint: 'Проект уйдёт из списка, задачи, связи и история сохранятся. Вернуть его можно в любой момент.',
    archiveButton: 'Архивировать проект',
    archiveTitle: 'Архивировать «{{name}}»?',
    archived: 'Проект «{{name}}» в архиве',
    archivedBanner: 'Проект «{{name}}» в архиве.',
    restore: 'Вернуть из архива',
    openSettings: 'Настройки',
    archiveNav: 'Архив · {{count}}',
  },
  backlinks: {
    title: 'Ссылаются на эту доску',
    hint: 'Доски и задачи, где есть ссылка на эту: карточка ссылки, адрес в тексте или [[…]] в задаче.',
    empty: 'Пока ничто не ссылается на эту доску.',
  },
  history: {
    title: 'История версий',
    save: 'Сохранить текущую версию',
    namePlaceholder: 'Название версии',
    name: 'Дать название',
    auto: 'Автосохранение',
    saved: 'Версия сохранена',
    empty: 'Версий пока нет. Они сохраняются сами каждые 10 минут работы и когда все уходят с доски.',
    today: 'Сегодня',
    yesterday: 'Вчера',
    restore: 'Восстановить',
    restoreTitle: 'Восстановить эту версию?',
    restoreConfirm: 'Доска станет такой, как в этой версии, у всех участников. Текущее состояние сохранится в истории, а отменить восстановление можно обычной отменой.',
    restored: 'Версия восстановлена. Отменить — {{keys}}',
    beforeRestore: 'До восстановления «{{name}}» ({{time}})',
    closePreview: 'Закрыть просмотр',
    offline: 'Нет связи с сервером. Восстановить версию можно, когда доска снова в сети.',
  },
  live: {
    react: 'Реакции',
    reactKeys: 'Клавиши 1–8 отправляют реакцию от курсора — её видят все.',
    raiseHand: 'Поднять руку',
    lowerHand: 'Опустить руку',
    hands: 'Поднятые руки',
    handsCount: 'Поднятые руки: {{n}}',
    noHands: 'Сейчас никто не поднял руку.',
    lowerAll: 'Опустить все руки',
    lowered: 'Все руки опущены',
    raised: '{{name}} поднимает руку',
    raisedMany: 'Поднятых рук: {{n}}',
    you: 'вы',
    stampHint: 'Клик по объекту ставит штамп, клик по своему штампу убирает его.',
    stampedBy: 'Поставили',
    andMore: 'и ещё {{n}}',
    laserHint: 'Ведите курсором: все участники видят красную указку.',
  },
  presentation: {
    exit: 'Выйти из презентации',
    slide: 'Слайд {{n}} из {{total}}',
  },
  links: {
    insert: 'Ссылка',
    title: 'Вставить ссылку',
    hint: 'На доске появится карточка с превью. Видео с YouTube, RUTUBE и VK Видео и файлы Figma можно смотреть прямо на доске.',
    placeholder: 'https://…',
    add: 'Вставить',
    invalid: 'Это не похоже на ссылку. Начните с https://',
    open: 'Открыть ссылку',
    play: 'Смотреть',
    view: 'Открыть просмотр',
    closePlayer: 'Закрыть плеер',
  },
  invite: {
    accepting: 'Принимаем приглашение…',
    needLogin: 'Войдите или зарегистрируйтесь, чтобы принять приглашение.',
    failed: 'Приглашение недействительно или уже принято.',
  },
  profile: {
    title: 'Профиль',
    color: 'Цвет курсора',
  },
  connect: {
    title: '«{{name}}» просит доступ к Ватману',
    text: 'Агент будет работать от вашего имени ({{name}}) и увидит только то, что доступно вам. Выберите, что ему можно.',
    back: 'После ответа вы вернётесь на {{host}}. Отключить приложение можно в профиле, в «ИИ-агенты и API-токены».',
    allow: 'Разрешить',
    deny: 'Отказать',
    unknown: 'Приложение не найдено или ссылка устарела. Начните подключение заново.',
  },
  activity: {
    title: 'Журнал действий',
    hint: 'Кто открывал доступ, добавлял и убирал людей, менял роли, удалял доски и задачи, подключал репозитории. Хранится год.',
    empty: 'Пока ничего не происходило.',
    more: 'Показать ещё',
    someone: 'Кто-то',
    on: 'включает',
    off: 'выключает',
    role: { owner: 'владелец', admin: 'администратор', member: 'участник', viewer: 'наблюдатель', commenter: 'комментатор', editor: 'редактор', reporter: 'автор заявок' },
    action: {
      'board.created': 'создаёт доску «{{target}}»',
      'board.access': 'меняет доступ к доске «{{target}}»: по ссылке — {{link}}, команде — {{team}}, организации — {{org}}',
      'board.invited': 'приглашает на доску «{{target}}» людей: {{count}}',
      'board.member_role': 'даёт {{subject}} роль «{{role}}» на доске «{{target}}»',
      'board.member_removed': 'убирает {{subject}} с доски «{{target}}»',
      'board.transferred': 'передаёт доску «{{target}}» человеку {{subject}}',
      'board.trashed': 'отправляет в корзину доску «{{target}}»',
      'board.restored': 'восстанавливает доску «{{target}}»',
      'board.deleted': 'удаляет навсегда доску «{{target}}»',
      'team.created': 'создаёт команду «{{target}}»',
      'team.invited': 'приглашает в команду «{{target}}» людей: {{count}}',
      'team.member_role': 'даёт {{subject}} роль «{{role}}» в команде «{{target}}»',
      'team.member_removed': 'убирает {{subject}} из команды «{{target}}»',
      'team.left': 'выходит из команды «{{target}}»',
      'team.agent_created': 'создаёт агента {{subject}} в команде «{{target}}»',
      'team.agent_removed': 'удаляет агента {{subject}} из команды «{{target}}»',
      'team.agent_token_created': 'выдаёт агенту {{subject}} токен «{{title}}»',
      'team.agent_token_revoked': 'отзывает токен агента {{subject}}',
      'org.settings': 'меняет настройки организации',
      'org.invited': 'приглашает в организацию людей: {{count}}',
      'org.member_role': 'даёт {{subject}} роль «{{role}}» в организации',
      'org.member_removed': 'убирает {{subject}} из организации',
      'org.left': 'выходит из организации',
      'org.guest_removed': 'убирает гостя {{subject}} из всех проектов и досок организации',
      'org.agents': '{{state}} ИИ-агентов в организации',
      'project.created': 'создаёт проект {{target}}',
      'space.created': 'создаёт пространство «{{target}}»',
      'space.renamed': 'переименовывает пространство «{{title}}» в «{{target}}»',
      'space.deleted': 'удаляет пространство «{{title}}» в команде «{{target}}»',
      'space.access': 'меняет доступ команды к пространству «{{target}}»: {{team}}',
      'space.member_role': 'даёт {{subject}} роль «{{role}}» в пространстве «{{target}}»',
      'space.member_removed': 'убирает {{subject}} из пространства «{{target}}»',
      'board.moved': 'переносит доску «{{target}}»',
      'project.moved': 'переносит проект {{target}} в другое пространство',
      'project.invited': 'приглашает по почте в проект {{target}} с ролью «{{role}}»',
      'project.archived': 'архивирует проект {{target}}',
      'project.restored': 'возвращает из архива проект {{target}}',
      'project.role': 'даёт {{subject}} роль «{{role}}» в проекте {{target}}',
      'project.role_removed': 'возвращает {{subject}} роль из команды в проекте {{target}}',
      'issue.deleted': 'удаляет задачу {{key}} «{{title}}»',
      'repo.connected': 'подключает репозиторий {{target}}',
      'repo.removed': 'отключает репозиторий {{target}}',
      'repo.secret_rotated': 'меняет секрет вебхука репозитория {{target}}',
      'import.started': 'запускает импорт {{key}} из {{system}} в команду «{{target}}»',
    },
  },
  update: { text: 'Вышла новая версия Ватмана — обновите страницу, чтобы продолжить работу.', reload: 'Обновить' },
  tokens: {
    connector: 'Без токена: в claude.ai и Claude Desktop добавьте свой коннектор с этим адресом — войдёте в Ватман и выберете, что агенту можно.',
    connection: 'подключение',
    moduleBoards: 'Доски',
    moduleTracker: 'Задачи',
    level: { write: 'Чтение и запись', read: 'Только чтение', none: 'Нет доступа' },
    menu: 'ИИ-агенты и API-токены',
    title: 'ИИ-агенты и API-токены',
    description: 'Токен подключает Claude и других ИИ-агентов к вашим доскам и задачам по протоколу MCP. Агент действует от вашего имени и видит только то, что доступно вам; редактировать может там, где вы редактор.',
    name: 'Название',
    access: 'Права',
    write: 'Чтение и запись',
    read: 'Только чтение',
    expires: 'Срок',
    days_one: '{{count}} день',
    days_few: '{{count}} дня',
    days_many: '{{count}} дней',
    days_other: '{{count}} дня',
    never: 'Бессрочно',
    create: 'Создать токен',
    copyOnce: 'Скопируйте токен сейчас: потом его не будет видно. Храните его как пароль.',
    token: 'Токен',
    claudeCode: 'Подключить в Claude Code',
    otherClients: 'Claude Desktop и другие MCP-клиенты: адрес {{url}}, заголовок Authorization: Bearer <токен>.',
    empty: 'Токенов пока нет.',
    created: 'создан {{when}}',
    used: 'использован {{when}}',
    unused: 'ещё не использовался',
    expiresAt: 'истекает {{when}}',
    expired: 'истёк',
    revoke: 'Отозвать',
    revokeTitle: 'Отозвать токен?',
    revokeText: 'Агенты с токеном «{{name}}» потеряют доступ к доскам и задачам в течение минуты.',
    tabTokens: 'Токены',
    tabLog: 'Журнал действий',
    tabAgents: 'Агенты-исполнители',
    boards: 'Доски',
    allBoards: 'Все мои доски и задачи',
    someBoards: 'Только выбранные доски',
    findBoard: 'Найти доску',
    picked_one: 'Выбрана {{count}} доска',
    picked_few: 'Выбрано {{count}} доски',
    picked_many: 'Выбрано {{count}} досок',
    picked_other: 'Выбрано {{count}} доски',
    boardsCount_one: '{{count}} доска',
    boardsCount_few: '{{count}} доски',
    boardsCount_many: '{{count}} досок',
    boardsCount_other: '{{count}} доски',
  },
  issueList: {
    insert: 'Задачи из трекера',
    newTitle: 'Список задач на доске',
    editTitle: 'Список задач',
    hint: 'Живой список задач по запросу: обновляется сам, а каждый видит то, что ему доступно в трекере.',
    project: 'Проект',
    allProjects: 'Все проекты',
    query: 'Запрос',
    queryHint: 'Язык поиска трекера: статус: открыта, исполнитель: я, спринт: текущий, #метка, сорт: приоритет.',
    name: 'Название',
    add: 'Добавить на доску',
    untitled: 'Задачи',
    loading: 'Загрузка…',
    empty: 'Задач нет',
    noAccess: 'Нет доступа к задачам',
    failed: 'Не удалось загрузить задачи',
    more_one: 'ещё {{count}}',
    more_few: 'ещё {{count}}',
    more_many: 'ещё {{count}}',
    more_other: 'ещё {{count}}',
    moreThan_one: 'больше {{count}}',
    moreThan_few: 'больше {{count}}',
    moreThan_many: 'больше {{count}}',
    moreThan_other: 'больше {{count}}',
  },
  guests: {
    title: 'Гости',
    allow: 'Разрешить приглашать людей со стороны',
    hint: 'Гость видит только доски и проекты, куда его пригласили. Когда выключено, приглашать можно только участников организации; уже приглашённые гости остаются, пока их не уберут.',
    empty: 'Гостей нет.',
    remove: 'Убрать доступ',
    removed: '{{name}} больше не видит ничего в организации',
    turnedOn: 'Гостей можно приглашать',
    turnedOff: 'Приглашать можно только своих',
  },
  spaces: {
    sharedFrom: 'Проект команды «{{team}}»: ваша команда в нём работает',
    title: 'Пространства',
    add: 'Создать',
    newSpace: 'Пространство',
    newTitle: 'Новое пространство',
    newHint: 'Пространство собирает доски и проекты задач одной темы: продукт, отдел, клиент. Создатель становится его администратором.',
    editTitle: 'Пространство',
    icon: 'Значок',
    iconUpload: 'Загрузить свою картинку',
    iconNone: 'Без значка',
    iconUnreadable: 'Не получилось открыть картинку',
    name: 'Название',
    namePlaceholder: 'Например, Маркетинг',
    description: 'Описание',
    descriptionPlaceholder: 'Что здесь лежит и для кого',
    team: 'Команда',
    teamHint: 'У команды сразу будет своё пространство «Общее».',
    space: 'Пространство',
    otherProjects: 'Другие проекты',
    guestProjects: 'Проекты, куда меня позвали',
    collapse: 'Свернуть',
    expand: 'Развернуть',
    moveTo: 'Переместить в пространство',
    notFound: 'Пространство не найдено или недоступно.',
    default: 'основное',
    edit: 'Изменить',
    delete: 'Удалить пространство',
    deleteTitle: 'Удалить пространство?',
    deleteText: 'Доски и проекты из «{{name}}» переедут в основное пространство команды, ничего не пропадёт.',
    deleted: 'Пространство «{{name}}» удалено, его содержимое — в основном',
    boards: 'Доски',
    tasks: 'Задачи',
    noProjects: 'Здесь пока нет проектов задач',
    noProjectsHint: 'Проект с ключом (например, PAY) собирает задачи, спринты и доску.',
    breadcrumb: 'Пространство',
    private: 'закрытое',
    privateOption: 'Закрытое пространство',
    privateOptionHint: 'Видят только те, кого вы добавите, и администраторы команды. Доступ можно поменять потом.',
    roles: {
      admin: 'Администратор',
      editor: 'Редактор',
      commenter: 'Комментатор',
      viewer: 'Читатель',
    },
    roleAbout: {
      admin: 'Меняет пространство и решает, кто в нём; управляет его досками и проектами, кроме закрытых досок.',
      editor: 'Создаёт доски и проекты и работает в них.',
      commenter: 'Смотрит и комментирует.',
      viewer: 'Только смотрит.',
    },
    access: {
      button: 'Доступ',
      title: 'Доступ к «{{name}}»',
      hint: 'Кто видит пространство и что делает с его досками и проектами. Доски и проекты могут дать меньше — или позвать кого-то ещё.',
      team: 'Вся команда «{{name}}»',
      teamLabel: 'Доступ команды',
      teamSize_one: '{{count}} человек',
      teamSize_few: '{{count}} человека',
      teamSize_many: '{{count}} человек',
      teamSize_other: '{{count}} человека',
      private: 'Нет доступа — закрытое',
      privateHint: 'Закрытое: только люди ниже',
      defaultOpen: 'Основное пространство всегда открыто команде: туда попадает всё, что создано без пространства.',
      people: 'Люди',
      teamAdmin: 'Администратор команды',
      fromOrg: 'из организации',
      you: 'вы',
      roleOf: 'Роль: {{name}}',
      remove: 'Убрать из пространства',
      leave: 'Выйти из пространства',
      left: 'Вы вышли из «{{name}}»',
      nobody: 'Отдельных ролей пока ни у кого нет — все из команды работают по доступу команды.',
      nobodyPrivate: 'Добавьте людей: кроме администраторов команды, сюда никто не попадёт.',
      add: 'Добавить человека',
      search: 'Имя или почта коллеги',
      newRole: 'Роль нового участника',
      noOne: 'Никого не нашли среди коллег.',
    },
  },
  agentAccounts: {
    intro: 'Агент — служебная учётка команды. Ему назначают задачи и упоминают его, как коллегу; ИИ-агент (например, Claude) работает от его имени по токену и узнаёт о новых задачах из своих уведомлений. Видит то же, что команда.',
    name: 'Имя агента',
    namePlaceholder: 'Например, Claude-разработчик',
    team: 'Команда',
    create: 'Создать агента',
    noTeams: 'Агентов создают владельцы и администраторы команд.',
    empty: 'Агентов пока нет.',
    badge: 'агент',
    createdBy: 'создал {{name}}',
    newToken: 'Выдать токен',
    noTokens: 'Токенов нет: агент пока не может работать.',
    rename: 'Переименовать',
    remove: 'Удалить агента',
    removeTitle: 'Удалить агента?',
    removeText: '«{{name}}» больше не сможет работать: его токены отзываются, а открытые задачи останутся без исполнителя. Его комментарии и правки сохранятся.',
    removed: 'Агент удалён',
    created: 'Агент создан — выдайте ему токен',
  },
  agents: {
    orgTitle: 'ИИ-агенты',
    allow: 'Разрешить ИИ-агентам работать с досками организации',
    allowHint: 'Claude и другие агенты подключаются по MCP с токенами участников. Когда выключено, агенты не видят и не меняют доски команд организации, даже с действующим токеном.',
    statusOn: 'ИИ-агентам разрешено работать с досками организации. Изменить это может администратор.',
    statusOff: 'Администратор отключил ИИ-агентов для досок организации.',
    turnedOn: 'ИИ-агенты включены',
    turnedOff: 'ИИ-агенты отключены',
    orgLog: 'Журнал действий агентов',
    everyone: 'Все люди',
    allBoards: 'Все доски',
    boardTitle: 'Действия ИИ-агентов',
    boardHint: 'Что делали агенты на этой доске: кто, каким токеном, какой инструмент и с какими объектами.',
    empty: 'Агенты пока ничего не делали.',
    more: 'Показать ещё',
    token: 'токен «{{name}}»',
    ms: 'мс',
    items_one: '{{count}} объект',
    items_few: '{{count}} объекта',
    items_many: '{{count}} объектов',
    items_other: '{{count}} объекта',
    tools: {
      list_boards: 'Список досок',
      create_board: 'Создал доску',
      get_board: 'Прочитал доску',
      search_board_text: 'Искал на доске',
      add_stickies: 'Добавил стикеры',
      add_shapes: 'Добавил фигуры',
      add_text: 'Добавил текст',
      add_frame: 'Добавил фрейм',
      connect: 'Соединил объекты',
      update_items: 'Изменил объекты',
      move_items: 'Переместил объекты',
      delete_items: 'Удалил объекты',
      create_mind_map: 'Нарисовал mind map',
      create_flowchart: 'Нарисовал блок-схему',
      insert_template: 'Вставил шаблон',
      get_board_image: 'Посмотрел картинку доски',
    },
  },
};

export default ru;
export type Dict = typeof ru;
